(function (a) {
  (a.fn.equalHeights = function () {
    var b = 0,
      c = a(this);
    return (
      c.each(function () {
        var c2 = a(this).innerHeight();
        c2 > b && (b = c2);
      }),
      c.css("height", b)
    );
  }),
    a("[data-equal]").each(function () {
      var b = a(this),
        c = b.data("equal");
      b.find(c).equalHeights();
    });
})(jQuery);
var afterResize = (function () {
  var t = {};
  return function (callback, ms, uniqueId) {
    uniqueId || (uniqueId = "Don't call this twice without a uniqueId"), t[uniqueId] && clearTimeout(t[uniqueId]), (t[uniqueId] = setTimeout(callback, ms));
  };
})();
window.theme = window.theme || {};
/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */ (function (a, b, c) {
  var d = window.matchMedia;
  typeof module != "undefined" && module.exports
    ? (module.exports = c(d))
    : typeof define == "function" && define.amd
    ? define(function () {
        return (b[a] = c(d));
      })
    : (b[a] = c(d));
})("enquire", this, function (a) {
  "use strict";
  function b(a2, b2) {
    var c2,
      d2 = 0,
      e2 = a2.length;
    for (d2; e2 > d2 && ((c2 = b2(a2[d2], d2)), c2 !== !1); d2++);
  }
  function c(a2) {
    return Object.prototype.toString.apply(a2) === "[object Array]";
  }
  function d(a2) {
    return typeof a2 == "function";
  }
  function e(a2) {
    (this.options = a2), !a2.deferSetup && this.setup();
  }
  function f(b2, c2) {
    (this.query = b2), (this.isUnconditional = c2), (this.handlers = []), (this.mql = a(b2));
    var d2 = this;
    (this.listener = function (a2) {
      (d2.mql = a2), d2.assess();
    }),
      this.mql.addListener(this.listener);
  }
  function g() {
    if (!a) throw new Error("matchMedia not present, legacy browsers require a polyfill");
    (this.queries = {}), (this.browserIsIncapable = !a("only all").matches);
  }
  return (
    (e.prototype = {
      setup: function () {
        this.options.setup && this.options.setup(), (this.initialised = !0);
      },
      on: function () {
        !this.initialised && this.setup(), this.options.match && this.options.match();
      },
      off: function () {
        this.options.unmatch && this.options.unmatch();
      },
      destroy: function () {
        this.options.destroy ? this.options.destroy() : this.off();
      },
      equals: function (a2) {
        return this.options === a2 || this.options.match === a2;
      },
    }),
    (f.prototype = {
      addHandler: function (a2) {
        var b2 = new e(a2);
        this.handlers.push(b2), this.matches() && b2.on();
      },
      removeHandler: function (a2) {
        var c2 = this.handlers;
        b(c2, function (b2, d2) {
          return b2.equals(a2) ? (b2.destroy(), !c2.splice(d2, 1)) : void 0;
        });
      },
      matches: function () {
        return this.mql.matches || this.isUnconditional;
      },
      clear: function () {
        b(this.handlers, function (a2) {
          a2.destroy();
        }),
          this.mql.removeListener(this.listener),
          (this.handlers.length = 0);
      },
      assess: function () {
        var a2 = this.matches() ? "on" : "off";
        b(this.handlers, function (b2) {
          b2[a2]();
        });
      },
    }),
    (g.prototype = {
      register: function (a2, e2, g2) {
        var h = this.queries,
          i = g2 && this.browserIsIncapable;
        return (
          h[a2] || (h[a2] = new f(a2, i)),
          d(e2) && (e2 = { match: e2 }),
          c(e2) || (e2 = [e2]),
          b(e2, function (b2) {
            d(b2) && (b2 = { match: b2 }), h[a2].addHandler(b2);
          }),
          this
        );
      },
      unregister: function (a2, b2) {
        var c2 = this.queries[a2];
        return c2 && (b2 ? c2.removeHandler(b2) : (c2.clear(), delete this.queries[a2])), this;
      },
    }),
    new g()
  );
}),
  (window.Modernizr = (function (a, b, c) {
    function z(a2) {
      j.cssText = a2;
    }
    function A(a2, b2) {
      return z(m.join(a2 + ";") + (b2 || ""));
    }
    function B(a2, b2) {
      return typeof a2 === b2;
    }
    function C(a2, b2) {
      return !!~("" + a2).indexOf(b2);
    }
    function D(a2, b2) {
      for (var d2 in a2) {
        var e2 = a2[d2];
        if (!C(e2, "-") && j[e2] !== c) return b2 == "pfx" ? e2 : !0;
      }
      return !1;
    }
    function E(a2, b2, d2) {
      for (var e2 in a2) {
        var f2 = b2[a2[e2]];
        if (f2 !== c) return d2 === !1 ? a2[e2] : B(f2, "function") ? f2.bind(d2 || b2) : f2;
      }
      return !1;
    }
    function F(a2, b2, c2) {
      var d2 = a2.charAt(0).toUpperCase() + a2.slice(1),
        e2 = (a2 + " " + o.join(d2 + " ") + d2).split(" ");
      return B(b2, "string") || B(b2, "undefined") ? D(e2, b2) : ((e2 = (a2 + " " + p.join(d2 + " ") + d2).split(" ")), E(e2, b2, c2));
    }
    var d = "2.8.2",
      e = {},
      f = !0,
      g = b.documentElement,
      h = "modernizr",
      i = b.createElement(h),
      j = i.style,
      k,
      l = {}.toString,
      m = " -webkit- -moz- -o- -ms- ".split(" "),
      n = "Webkit Moz O ms",
      o = n.split(" "),
      p = n.toLowerCase().split(" "),
      q = {},
      r = {},
      s = {},
      t = [],
      u = t.slice,
      v,
      w = function (a2, c2, d2, e2) {
        var f2,
          i2,
          j2,
          k2,
          l2 = b.createElement("div"),
          m2 = b.body,
          n2 = m2 || b.createElement("body");
        if (parseInt(d2, 10)) for (; d2--; ) (j2 = b.createElement("div")), (j2.id = e2 ? e2[d2] : h + (d2 + 1)), l2.appendChild(j2);
        return (
          (f2 = ["&#173;", '<style id="s', h, '">', a2, "</style>"].join("")),
          (l2.id = h),
          ((m2 ? l2 : n2).innerHTML += f2),
          n2.appendChild(l2),
          m2 || ((n2.style.background = ""), (n2.style.overflow = "hidden"), (k2 = g.style.overflow), (g.style.overflow = "hidden"), g.appendChild(n2)),
          (i2 = c2(l2, a2)),
          m2 ? l2.parentNode.removeChild(l2) : (n2.parentNode.removeChild(n2), (g.style.overflow = k2)),
          !!i2
        );
      },
      x2 = {}.hasOwnProperty,
      y;
    !B(x2, "undefined") && !B(x2.call, "undefined")
      ? (y = function (a2, b2) {
          return x2.call(a2, b2);
        })
      : (y = function (a2, b2) {
          return b2 in a2 && B(a2.constructor.prototype[b2], "undefined");
        }),
      Function.prototype.bind ||
        (Function.prototype.bind = function (b2) {
          var c2 = this;
          if (typeof c2 != "function") throw new TypeError();
          var d2 = u.call(arguments, 1),
            e2 = function () {
              if (this instanceof e2) {
                var a2 = function () {};
                a2.prototype = c2.prototype;
                var f2 = new a2(),
                  g2 = c2.apply(f2, d2.concat(u.call(arguments)));
                return Object(g2) === g2 ? g2 : f2;
              }
              return c2.apply(b2, d2.concat(u.call(arguments)));
            };
          return e2;
        }),
      (q.touch = function () {
        var c2;
        return (
          "ontouchstart" in a || (a.DocumentTouch && b instanceof DocumentTouch)
            ? (c2 = !0)
            : w(["@media (", m.join("touch-enabled),("), h, ")", "{#modernizr{top:9px;position:absolute}}"].join(""), function (a2) {
                c2 = a2.offsetTop === 9;
              }),
          c2
        );
      }),
      (q.csstransforms = function () {
        return !!F("transform");
      }),
      (q.csstransforms3d = function () {
        var a2 = !!F("perspective");
        return (
          a2 &&
            "webkitPerspective" in g.style &&
            w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function (b2, c2) {
              a2 = b2.offsetLeft === 9 && b2.offsetHeight === 3;
            }),
          a2
        );
      }),
      (q.fontface = function () {
        var a2;
        return (
          w('@font-face {font-family:"font";src:url("https://")}', function (c2, d2) {
            var e2 = b.getElementById("smodernizr"),
              f2 = e2.sheet || e2.styleSheet,
              g2 = f2 ? (f2.cssRules && f2.cssRules[0] ? f2.cssRules[0].cssText : f2.cssText || "") : "";
            a2 = /src/i.test(g2) && g2.indexOf(d2.split(" ")[0]) === 0;
          }),
          a2
        );
      });
    for (var G in q) y(q, G) && ((v = G.toLowerCase()), (e[v] = q[G]()), t.push((e[v] ? "" : "no-") + v));
    return (
      (e.addTest = function (a2, b2) {
        if (typeof a2 == "object") for (var d2 in a2) y(a2, d2) && e.addTest(d2, a2[d2]);
        else {
          if (((a2 = a2.toLowerCase()), e[a2] !== c)) return e;
          (b2 = typeof b2 == "function" ? b2() : b2), typeof f != "undefined" && f && (g.className += " supports-" + (b2 ? "" : "no-") + a2), (e[a2] = b2);
        }
        return e;
      }),
      z(""),
      (i = k = null),
      (e._version = d),
      (e._prefixes = m),
      (e._domPrefixes = p),
      (e._cssomPrefixes = o),
      (e.testProp = function (a2) {
        return D([a2]);
      }),
      (e.testAllProps = F),
      (e.testStyles = w),
      (g.className = g.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (f ? " supports-js supports-" + t.join(" supports-") : "")),
      e
    );
  })(this, this.document));
/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */ (function () {
  function n(n2, t2) {
    for (var r2 = -1, e2 = t2.length, u2 = n2.length; ++r2 < e2; ) n2[u2 + r2] = t2[r2];
    return n2;
  }
  function t(n2, t2, r2) {
    for (var e2 = -1, u2 = n2.length; ++e2 < u2; ) {
      var o2 = n2[e2],
        i2 = t2(o2);
      if (i2 != null && (c2 === an ? i2 === i2 : r2(i2, c2)))
        var c2 = i2,
          f2 = o2;
    }
    return f2;
  }
  function r(n2, t2, r2) {
    var e2;
    return (
      r2(n2, function (n3, r3, u2) {
        return t2(n3, r3, u2) ? ((e2 = n3), !1) : void 0;
      }),
      e2
    );
  }
  function e(n2, t2, r2, e2, u2) {
    return (
      u2(n2, function (n3, u3, o2) {
        r2 = e2 ? ((e2 = !1), n3) : t2(r2, n3, u3, o2);
      }),
      r2
    );
  }
  function u(n2, t2) {
    return O(t2, function (t3) {
      return n2[t3];
    });
  }
  function o(n2) {
    return n2 && n2.Object === Object ? n2 : null;
  }
  function i(n2) {
    return vn[n2];
  }
  function c(n2) {
    var t2 = !1;
    if (n2 != null && typeof n2.toString != "function")
      try {
        t2 = !!(n2 + "");
      } catch (r2) {}
    return t2;
  }
  function f(n2, t2) {
    return (n2 = typeof n2 == "number" || hn.test(n2) ? +n2 : -1), n2 > -1 && n2 % 1 == 0 && (t2 == null ? 9007199254740991 : t2) > n2;
  }
  function a(n2) {
    if (Y(n2) && !Pn(n2)) {
      if (n2 instanceof l) return n2;
      if (En.call(n2, "__wrapped__")) {
        var t2 = new l(n2.__wrapped__, n2.__chain__);
        return (t2.__actions__ = N(n2.__actions__)), t2;
      }
    }
    return new l(n2);
  }
  function l(n2, t2) {
    (this.__wrapped__ = n2), (this.__actions__ = []), (this.__chain__ = !!t2);
  }
  function p(n2, t2, r2, e2) {
    var u2;
    return (u2 = n2 === an) || ((u2 = xn[r2]), (u2 = (n2 === u2 || (n2 !== n2 && u2 !== u2)) && !En.call(e2, r2))), u2 ? t2 : n2;
  }
  function s(n2) {
    return X(n2) ? Fn(n2) : {};
  }
  function h(n2, t2, r2) {
    if (typeof n2 != "function") throw new TypeError("Expected a function");
    return setTimeout(function () {
      n2.apply(an, r2);
    }, t2);
  }
  function v(n2, t2) {
    var r2 = !0;
    return (
      $n(n2, function (n3, e2, u2) {
        return (r2 = !!t2(n3, e2, u2));
      }),
      r2
    );
  }
  function y(n2, t2) {
    var r2 = [];
    return (
      $n(n2, function (n3, e2, u2) {
        t2(n3, e2, u2) && r2.push(n3);
      }),
      r2
    );
  }
  function _2(t2, r2, e2, u2) {
    u2 || (u2 = []);
    for (var o2 = -1, i2 = t2.length; ++o2 < i2; ) {
      var c2 = t2[o2];
      r2 > 0 && Y(c2) && L(c2) && (e2 || Pn(c2) || K(c2)) ? (r2 > 1 ? _2(c2, r2 - 1, e2, u2) : n(u2, c2)) : e2 || (u2[u2.length] = c2);
    }
    return u2;
  }
  function g(n2, t2) {
    return n2 && qn(n2, t2, en);
  }
  function b(n2, t2) {
    return y(t2, function (t3) {
      return Q(n2[t3]);
    });
  }
  function j(n2, t2, r2, e2, u2) {
    return n2 === t2 ? !0 : n2 == null || t2 == null || (!X(n2) && !Y(t2)) ? n2 !== n2 && t2 !== t2 : m(n2, t2, j, r2, e2, u2);
  }
  function m(n2, t2, r2, e2, u2, o2) {
    var i2 = Pn(n2),
      f2 = Pn(t2),
      a2 = "[object Array]",
      l2 = "[object Array]";
    i2 || ((a2 = kn.call(n2)), a2 == "[object Arguments]" && (a2 = "[object Object]")), f2 || ((l2 = kn.call(t2)), l2 == "[object Arguments]" && (l2 = "[object Object]"));
    var p2 = a2 == "[object Object]" && !c(n2),
      f2 = l2 == "[object Object]" && !c(t2);
    return !(l2 = a2 == l2) || i2 || p2
      ? 2 & u2 || ((a2 = p2 && En.call(n2, "__wrapped__")), (f2 = f2 && En.call(t2, "__wrapped__")), !a2 && !f2)
        ? l2
          ? (o2 || (o2 = []),
            (a2 = J(o2, function (t3) {
              return t3[0] === n2;
            })) && a2[1]
              ? a2[1] == t2
              : (o2.push([n2, t2]), (t2 = (i2 ? I : q)(n2, t2, r2, e2, u2, o2)), o2.pop(), t2))
          : !1
        : r2(a2 ? n2.value() : n2, f2 ? t2.value() : t2, e2, u2, o2)
      : $2(n2, t2, a2);
  }
  function d(n2) {
    var t2 = typeof n2;
    return t2 == "function" ? n2 : n2 == null ? cn : (t2 == "object" ? x2 : A)(n2);
  }
  function w(n2) {
    n2 = n2 == null ? n2 : Object(n2);
    var t2,
      r2 = [];
    for (t2 in n2) r2.push(t2);
    return r2;
  }
  function O(n2, t2) {
    var r2 = -1,
      e2 = L(n2) ? Array(n2.length) : [];
    return (
      $n(n2, function (n3, u2, o2) {
        e2[++r2] = t2(n3, u2, o2);
      }),
      e2
    );
  }
  function x2(n2) {
    var t2 = en(n2);
    return function (r2) {
      var e2 = t2.length;
      if (r2 == null) return !e2;
      for (r2 = Object(r2); e2--; ) {
        var u2 = t2[e2];
        if (!(u2 in r2 && j(n2[u2], r2[u2], an, 3))) return !1;
      }
      return !0;
    };
  }
  function E(n2, t2) {
    return (
      (n2 = Object(n2)),
      P(
        t2,
        function (t3, r2) {
          return r2 in n2 && (t3[r2] = n2[r2]), t3;
        },
        {}
      )
    );
  }
  function A(n2) {
    return function (t2) {
      return t2 == null ? an : t2[n2];
    };
  }
  function k(n2, t2, r2) {
    var e2 = -1,
      u2 = n2.length;
    for (0 > t2 && (t2 = -t2 > u2 ? 0 : u2 + t2), r2 = r2 > u2 ? u2 : r2, 0 > r2 && (r2 += u2), u2 = t2 > r2 ? 0 : (r2 - t2) >>> 0, t2 >>>= 0, r2 = Array(u2); ++e2 < u2; ) r2[e2] = n2[e2 + t2];
    return r2;
  }
  function N(n2) {
    return k(n2, 0, n2.length);
  }
  function S(n2, t2) {
    var r2;
    return (
      $n(n2, function (n3, e2, u2) {
        return (r2 = t2(n3, e2, u2)), !r2;
      }),
      !!r2
    );
  }
  function T(t2, r2) {
    return P(
      r2,
      function (t3, r3) {
        return r3.func.apply(r3.thisArg, n([t3], r3.args));
      },
      t2
    );
  }
  function F(n2, t2, r2, e2) {
    r2 || (r2 = {});
    for (var u2 = -1, o2 = t2.length; ++u2 < o2; ) {
      var i2 = t2[u2],
        c2 = e2 ? e2(r2[i2], n2[i2], i2, r2, n2) : n2[i2],
        f2 = r2,
        a2 = f2[i2];
      (En.call(f2, i2) && (a2 === c2 || (a2 !== a2 && c2 !== c2)) && (c2 !== an || i2 in f2)) || (f2[i2] = c2);
    }
    return r2;
  }
  function R(n2) {
    return V(function (t2, r2) {
      var e2 = -1,
        u2 = r2.length,
        o2 = u2 > 1 ? r2[u2 - 1] : an,
        o2 = typeof o2 == "function" ? (u2--, o2) : an;
      for (t2 = Object(t2); ++e2 < u2; ) {
        var i2 = r2[e2];
        i2 && n2(t2, i2, e2, o2);
      }
      return t2;
    });
  }
  function B(n2) {
    return function () {
      var t2 = arguments,
        r2 = s(n2.prototype),
        t2 = n2.apply(r2, t2);
      return X(t2) ? t2 : r2;
    };
  }
  function D(n2, t2, r2) {
    function e2() {
      for (var o2 = -1, i2 = arguments.length, c2 = -1, f2 = r2.length, a2 = Array(f2 + i2), l2 = this && this !== wn && this instanceof e2 ? u2 : n2; ++c2 < f2; ) a2[c2] = r2[c2];
      for (; i2--; ) a2[c2++] = arguments[++o2];
      return l2.apply(t2, a2);
    }
    if (typeof n2 != "function") throw new TypeError("Expected a function");
    var u2 = B(n2);
    return e2;
  }
  function I(n2, t2, r2, e2, u2, o2) {
    var i2 = -1,
      c2 = 1 & u2,
      f2 = n2.length,
      a2 = t2.length;
    if (f2 != a2 && !(2 & u2 && a2 > f2)) return !1;
    for (a2 = !0; ++i2 < f2; ) {
      var l2 = n2[i2],
        p2 = t2[i2];
      if (an !== void 0) {
        a2 = !1;
        break;
      }
      if (c2) {
        if (
          !S(t2, function (n3) {
            return l2 === n3 || r2(l2, n3, e2, u2, o2);
          })
        ) {
          a2 = !1;
          break;
        }
      } else if (l2 !== p2 && !r2(l2, p2, e2, u2, o2)) {
        a2 = !1;
        break;
      }
    }
    return a2;
  }
  function $2(n2, t2, r2) {
    switch (r2) {
      case "[object Boolean]":
      case "[object Date]":
        return +n2 == +t2;
      case "[object Error]":
        return n2.name == t2.name && n2.message == t2.message;
      case "[object Number]":
        return n2 != +n2 ? t2 != +t2 : n2 == +t2;
      case "[object RegExp]":
      case "[object String]":
        return n2 == t2 + "";
    }
    return !1;
  }
  function q(n2, t2, r2, e2, u2, o2) {
    var i2 = 2 & u2,
      c2 = en(n2),
      f2 = c2.length,
      a2 = en(t2).length;
    if (f2 != a2 && !i2) return !1;
    for (var l2 = f2; l2--; ) {
      var p2 = c2[l2];
      if (!(i2 ? p2 in t2 : En.call(t2, p2))) return !1;
    }
    for (a2 = !0; ++l2 < f2; ) {
      var p2 = c2[l2],
        s2 = n2[p2],
        h2 = t2[p2];
      if (an !== void 0 || (s2 !== h2 && !r2(s2, h2, e2, u2, o2))) {
        a2 = !1;
        break;
      }
      i2 || (i2 = p2 == "constructor");
    }
    return (
      a2 && !i2 && ((r2 = n2.constructor), (e2 = t2.constructor), r2 != e2 && "constructor" in n2 && "constructor" in t2 && !(typeof r2 == "function" && r2 instanceof r2 && typeof e2 == "function" && e2 instanceof e2) && (a2 = !1)), a2
    );
  }
  function z(n2) {
    var t2 = n2 ? n2.length : an;
    if (W(t2) && (Pn(n2) || nn(n2) || K(n2))) {
      n2 = String;
      for (var r2 = -1, e2 = Array(t2); ++r2 < t2; ) e2[r2] = n2(r2);
      t2 = e2;
    } else t2 = null;
    return t2;
  }
  function C(n2) {
    var t2 = n2 && n2.constructor,
      t2 = (Q(t2) && t2.prototype) || xn;
    return n2 === t2;
  }
  function G(n2) {
    return n2 ? n2[0] : an;
  }
  function J(n2, t2) {
    return r(n2, d(t2), $n);
  }
  function M(n2, t2) {
    return $n(n2, typeof t2 == "function" ? t2 : cn);
  }
  function P(n2, t2, r2) {
    return e(n2, d(t2), r2, 3 > arguments.length, $n);
  }
  function U(n2, t2) {
    var r2;
    if (typeof t2 != "function") throw new TypeError("Expected a function");
    return (
      (n2 = Un(n2)),
      function () {
        return 0 < --n2 && (r2 = t2.apply(this, arguments)), 1 >= n2 && (t2 = an), r2;
      }
    );
  }
  function V(n2) {
    var t2;
    if (typeof n2 != "function") throw new TypeError("Expected a function");
    return (
      (t2 = In(t2 === an ? n2.length - 1 : Un(t2), 0)),
      function () {
        for (var r2 = arguments, e2 = -1, u2 = In(r2.length - t2, 0), o2 = Array(u2); ++e2 < u2; ) o2[e2] = r2[t2 + e2];
        for (u2 = Array(t2 + 1), e2 = -1; ++e2 < t2; ) u2[e2] = r2[e2];
        return (u2[t2] = o2), n2.apply(this, u2);
      }
    );
  }
  function H(n2, t2) {
    return n2 > t2;
  }
  function K(n2) {
    return Y(n2) && L(n2) && En.call(n2, "callee") && (!Rn.call(n2, "callee") || kn.call(n2) == "[object Arguments]");
  }
  function L(n2) {
    return n2 != null && !(typeof n2 == "function" && Q(n2)) && W(zn(n2));
  }
  function Q(n2) {
    return (n2 = X(n2) ? kn.call(n2) : ""), n2 == "[object Function]" || n2 == "[object GeneratorFunction]";
  }
  function W(n2) {
    return typeof n2 == "number" && n2 > -1 && n2 % 1 == 0 && 9007199254740991 >= n2;
  }
  function X(n2) {
    var t2 = typeof n2;
    return !!n2 && (t2 == "object" || t2 == "function");
  }
  function Y(n2) {
    return !!n2 && typeof n2 == "object";
  }
  function Z(n2) {
    return typeof n2 == "number" || (Y(n2) && kn.call(n2) == "[object Number]");
  }
  function nn(n2) {
    return typeof n2 == "string" || (!Pn(n2) && Y(n2) && kn.call(n2) == "[object String]");
  }
  function tn(n2, t2) {
    return t2 > n2;
  }
  function rn(n2) {
    return typeof n2 == "string" ? n2 : n2 == null ? "" : n2 + "";
  }
  function en(n2) {
    var t2 = C(n2);
    if (!t2 && !L(n2)) return Dn(Object(n2));
    var r2,
      e2 = z(n2),
      u2 = !!e2,
      e2 = e2 || [],
      o2 = e2.length;
    for (r2 in n2) !En.call(n2, r2) || (u2 && (r2 == "length" || f(r2, o2))) || (t2 && r2 == "constructor") || e2.push(r2);
    return e2;
  }
  function un(n2) {
    for (var t2 = -1, r2 = C(n2), e2 = w(n2), u2 = e2.length, o2 = z(n2), i2 = !!o2, o2 = o2 || [], c2 = o2.length; ++t2 < u2; ) {
      var a2 = e2[t2];
      (i2 && (a2 == "length" || f(a2, c2))) || (a2 == "constructor" && (r2 || !En.call(n2, a2))) || o2.push(a2);
    }
    return o2;
  }
  function on(n2) {
    return n2 ? u(n2, en(n2)) : [];
  }
  function cn(n2) {
    return n2;
  }
  function fn(t2, r2, e2) {
    var u2 = en(r2),
      o2 = b(r2, u2);
    e2 != null || (X(r2) && (o2.length || !u2.length)) || ((e2 = r2), (r2 = t2), (t2 = this), (o2 = b(r2, en(r2))));
    var i2 = X(e2) && "chain" in e2 ? e2.chain : !0,
      c2 = Q(t2);
    return (
      $n(o2, function (e3) {
        var u3 = r2[e3];
        (t2[e3] = u3),
          c2 &&
            (t2.prototype[e3] = function () {
              var r3 = this.__chain__;
              if (i2 || r3) {
                var e4 = t2(this.__wrapped__);
                return (e4.__actions__ = N(this.__actions__)).push({ func: u3, args: arguments, thisArg: t2 }), (e4.__chain__ = r3), e4;
              }
              return u3.apply(t2, n([this.value()], arguments));
            });
      }),
      t2
    );
  }
  var an,
    ln = 1 / 0,
    pn = /[&<>"'`]/g,
    sn = RegExp(pn.source),
    hn = /^(?:0|[1-9]\d*)$/,
    vn = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" },
    yn = { function: !0, object: !0 },
    _n = yn[typeof exports] && exports && !exports.nodeType ? exports : an,
    gn = yn[typeof module] && module && !module.nodeType ? module : an,
    bn = gn && gn.exports === _n ? _n : an,
    jn = o(yn[typeof self] && self),
    mn = o(yn[typeof window] && window),
    dn = o(yn[typeof this] && this),
    wn = o(_n && gn && typeof global == "object" && global) || (mn !== (dn && dn.window) && mn) || jn || dn || Function("return this")(),
    On = Array.prototype,
    xn = Object.prototype,
    En = xn.hasOwnProperty,
    An = 0,
    kn = xn.toString,
    Nn = wn._,
    Sn = wn.Reflect,
    Tn = Sn ? Sn.f : an,
    Fn = Object.create,
    Rn = xn.propertyIsEnumerable,
    Bn = wn.isFinite,
    Dn = Object.keys,
    In = Math.max,
    $n = (function (n2, t2) {
      return function (r2, e2) {
        if (r2 == null) return r2;
        if (!L(r2)) return n2(r2, e2);
        for (var u2 = r2.length, o2 = t2 ? u2 : -1, i2 = Object(r2); (t2 ? o2-- : ++o2 < u2) && e2(i2[o2], o2, i2) !== !1; );
        return r2;
      };
    })(g),
    qn = (function (n2) {
      return function (t2, r2, e2) {
        var u2 = -1,
          o2 = Object(t2);
        e2 = e2(t2);
        for (var i2 = e2.length; i2--; ) {
          var c2 = e2[n2 ? i2 : ++u2];
          if (r2(o2[c2], c2, o2) === !1) break;
        }
        return t2;
      };
    })();
  Tn &&
    !Rn.call({ valueOf: 1 }, "valueOf") &&
    (w = function (n2) {
      n2 = Tn(n2);
      for (var t2, r2 = []; !(t2 = n2.next()).done; ) r2.push(t2.value);
      return r2;
    });
  var zn = A("length"),
    Cn = V(function (t2, r2) {
      return Pn(t2) || (t2 = t2 == null ? [] : [Object(t2)]), _2(r2, 1), n(N(t2), on);
    }),
    Gn = V(function (n2, t2, r2) {
      return D(n2, t2, r2);
    }),
    Jn = V(function (n2, t2) {
      return h(n2, 1, t2);
    }),
    Mn = V(function (n2, t2, r2) {
      return h(n2, Vn(t2) || 0, r2);
    }),
    Pn = Array.isArray,
    Un = Number,
    Vn = Number,
    Hn = R(function (n2, t2) {
      F(t2, en(t2), n2);
    }),
    Kn = R(function (n2, t2) {
      F(t2, un(t2), n2);
    }),
    Ln = R(function (n2, t2, r2, e2) {
      F(t2, un(t2), n2, e2);
    }),
    Qn = V(function (n2) {
      return n2.push(an, p), Ln.apply(an, n2);
    }),
    Wn = V(function (n2, t2) {
      return n2 == null ? {} : E(n2, _2(t2, 1));
    }),
    Xn = d;
  (l.prototype = s(a.prototype)),
    (l.prototype.constructor = l),
    (a.assignIn = Kn),
    (a.before = U),
    (a.bind = Gn),
    (a.chain = function (n2) {
      return (n2 = a(n2)), (n2.__chain__ = !0), n2;
    }),
    (a.compact = function (n2) {
      return y(n2, Boolean);
    }),
    (a.concat = Cn),
    (a.create = function (n2, t2) {
      var r2 = s(n2);
      return t2 ? Hn(r2, t2) : r2;
    }),
    (a.defaults = Qn),
    (a.defer = Jn),
    (a.delay = Mn),
    (a.filter = function (n2, t2) {
      return y(n2, d(t2));
    }),
    (a.flatten = function (n2) {
      return n2 && n2.length ? _2(n2, 1) : [];
    }),
    (a.flattenDeep = function (n2) {
      return n2 && n2.length ? _2(n2, ln) : [];
    }),
    (a.iteratee = Xn),
    (a.keys = en),
    (a.map = function (n2, t2) {
      return O(n2, d(t2));
    }),
    (a.matches = function (n2) {
      return x2(Hn({}, n2));
    }),
    (a.mixin = fn),
    (a.negate = function (n2) {
      if (typeof n2 != "function") throw new TypeError("Expected a function");
      return function () {
        return !n2.apply(this, arguments);
      };
    }),
    (a.once = function (n2) {
      return U(2, n2);
    }),
    (a.pick = Wn),
    (a.slice = function (n2, t2, r2) {
      var e2 = n2 ? n2.length : 0;
      return (r2 = r2 === an ? e2 : +r2), e2 ? k(n2, t2 == null ? 0 : +t2, r2) : [];
    }),
    (a.sortBy = function (n2, t2) {
      var r2 = 0;
      return (
        (t2 = d(t2)),
        O(
          O(n2, function (n3, e2, u2) {
            return { c: n3, b: r2++, a: t2(n3, e2, u2) };
          }).sort(function (n3, t3) {
            var r3;
            n: {
              r3 = n3.a;
              var e2 = t3.a;
              if (r3 !== e2) {
                var u2 = r3 === null,
                  o2 = r3 === an,
                  i2 = r3 === r3,
                  c2 = e2 === null,
                  f2 = e2 === an,
                  a2 = e2 === e2;
                if ((r3 > e2 && !c2) || !i2 || (u2 && !f2 && a2) || (o2 && a2)) {
                  r3 = 1;
                  break n;
                }
                if ((e2 > r3 && !u2) || !a2 || (c2 && !o2 && i2) || (f2 && i2)) {
                  r3 = -1;
                  break n;
                }
              }
              r3 = 0;
            }
            return r3 || n3.b - t3.b;
          }),
          A("c")
        )
      );
    }),
    (a.tap = function (n2, t2) {
      return t2(n2), n2;
    }),
    (a.thru = function (n2, t2) {
      return t2(n2);
    }),
    (a.toArray = function (n2) {
      return L(n2) ? (n2.length ? N(n2) : []) : on(n2);
    }),
    (a.values = on),
    (a.extend = Kn),
    fn(a, a),
    (a.clone = function (n2) {
      return X(n2) ? (Pn(n2) ? N(n2) : F(n2, en(n2))) : n2;
    }),
    (a.escape = function (n2) {
      return (n2 = rn(n2)) && sn.test(n2) ? n2.replace(pn, i) : n2;
    }),
    (a.every = function (n2, t2, r2) {
      return (t2 = r2 ? an : t2), v(n2, d(t2));
    }),
    (a.find = J),
    (a.forEach = M),
    (a.has = function (n2, t2) {
      return n2 != null && En.call(n2, t2);
    }),
    (a.head = G),
    (a.identity = cn),
    (a.indexOf = function (n2, t2, r2) {
      var e2 = n2 ? n2.length : 0;
      (r2 = typeof r2 == "number" ? (0 > r2 ? In(e2 + r2, 0) : r2) : 0), (r2 = (r2 || 0) - 1);
      for (var u2 = t2 === t2; ++r2 < e2; ) {
        var o2 = n2[r2];
        if (u2 ? o2 === t2 : o2 !== o2) return r2;
      }
      return -1;
    }),
    (a.isArguments = K),
    (a.isArray = Pn),
    (a.isBoolean = function (n2) {
      return n2 === !0 || n2 === !1 || (Y(n2) && kn.call(n2) == "[object Boolean]");
    }),
    (a.isDate = function (n2) {
      return Y(n2) && kn.call(n2) == "[object Date]";
    }),
    (a.isEmpty = function (n2) {
      if (L(n2) && (Pn(n2) || nn(n2) || Q(n2.splice) || K(n2))) return !n2.length;
      for (var t2 in n2) if (En.call(n2, t2)) return !1;
      return !0;
    }),
    (a.isEqual = function (n2, t2) {
      return j(n2, t2);
    }),
    (a.isFinite = function (n2) {
      return typeof n2 == "number" && Bn(n2);
    }),
    (a.isFunction = Q),
    (a.isNaN = function (n2) {
      return Z(n2) && n2 != +n2;
    }),
    (a.isNull = function (n2) {
      return n2 === null;
    }),
    (a.isNumber = Z),
    (a.isObject = X),
    (a.isRegExp = function (n2) {
      return X(n2) && kn.call(n2) == "[object RegExp]";
    }),
    (a.isString = nn),
    (a.isUndefined = function (n2) {
      return n2 === an;
    }),
    (a.last = function (n2) {
      var t2 = n2 ? n2.length : 0;
      return t2 ? n2[t2 - 1] : an;
    }),
    (a.max = function (n2) {
      return n2 && n2.length ? t(n2, cn, H) : an;
    }),
    (a.min = function (n2) {
      return n2 && n2.length ? t(n2, cn, tn) : an;
    }),
    (a.noConflict = function () {
      return wn._ === this && (wn._ = Nn), this;
    }),
    (a.noop = function () {}),
    (a.reduce = P),
    (a.result = function (n2, t2, r2) {
      return (t2 = n2 == null ? an : n2[t2]), t2 === an && (t2 = r2), Q(t2) ? t2.call(n2) : t2;
    }),
    (a.size = function (n2) {
      return n2 == null ? 0 : ((n2 = L(n2) ? n2 : en(n2)), n2.length);
    }),
    (a.some = function (n2, t2, r2) {
      return (t2 = r2 ? an : t2), S(n2, d(t2));
    }),
    (a.uniqueId = function (n2) {
      var t2 = ++An;
      return rn(n2) + t2;
    }),
    (a.each = M),
    (a.first = G),
    fn(
      a,
      (function () {
        var n2 = {};
        return (
          g(a, function (t2, r2) {
            En.call(a.prototype, r2) || (n2[r2] = t2);
          }),
          n2
        );
      })(),
      { chain: !1 }
    ),
    (a.VERSION = "4.5.1"),
    $n("pop join replace reverse split push shift sort splice unshift".split(" "), function (n2) {
      var t2 = (/^(?:replace|split)$/.test(n2) ? String.prototype : On)[n2],
        r2 = /^(?:push|sort|unshift)$/.test(n2) ? "tap" : "thru",
        e2 = /^(?:pop|join|replace|shift)$/.test(n2);
      a.prototype[n2] = function () {
        var n3 = arguments;
        return e2 && !this.__chain__
          ? t2.apply(this.value(), n3)
          : this[r2](function (r3) {
              return t2.apply(r3, n3);
            });
      };
    }),
    (a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = function () {
      return T(this.__wrapped__, this.__actions__);
    }),
    ((mn || jn || {})._ = a),
    typeof define == "function" && typeof define.amd == "object" && define.amd
      ? define(function () {
          return a;
        })
      : _n && gn
      ? (bn && ((gn.exports = a)._ = a), (_n._ = a))
      : (wn._ = a);
}.call(this));
/*!
 * imagesLoaded PACKAGED v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function (t, e) {
  typeof define == "function" && define.amd ? define("ev-emitter/ev-emitter", e) : typeof module == "object" && module.exports ? (module.exports = e()) : (t.EvEmitter = e());
})(typeof window != "undefined" ? window : this, function () {
  function t() {}
  var e = t.prototype;
  return (
    (e.on = function (t2, e2) {
      if (t2 && e2) {
        var i = (this._events = this._events || {}),
          n = (i[t2] = i[t2] || []);
        return n.indexOf(e2) == -1 && n.push(e2), this;
      }
    }),
    (e.once = function (t2, e2) {
      if (t2 && e2) {
        this.on(t2, e2);
        var i = (this._onceEvents = this._onceEvents || {}),
          n = (i[t2] = i[t2] || {});
        return (n[e2] = !0), this;
      }
    }),
    (e.off = function (t2, e2) {
      var i = this._events && this._events[t2];
      if (i && i.length) {
        var n = i.indexOf(e2);
        return n != -1 && i.splice(n, 1), this;
      }
    }),
    (e.emitEvent = function (t2, e2) {
      var i = this._events && this._events[t2];
      if (i && i.length) {
        var n = 0,
          o = i[n];
        e2 = e2 || [];
        for (var r = this._onceEvents && this._onceEvents[t2]; o; ) {
          var s = r && r[o];
          s && (this.off(t2, o), delete r[o]), o.apply(this, e2), (n += s ? 0 : 1), (o = i[n]);
        }
        return this;
      }
    }),
    t
  );
}),
  (function (t, e) {
    "use strict";
    typeof define == "function" && define.amd
      ? define(["ev-emitter/ev-emitter"], function (i) {
          return e(t, i);
        })
      : typeof module == "object" && module.exports
      ? (module.exports = e(t, require("ev-emitter")))
      : (t.imagesLoaded = e(t, t.EvEmitter));
  })(window, function (t, e) {
    function i(t2, e2) {
      for (var i2 in e2) t2[i2] = e2[i2];
      return t2;
    }
    function n(t2) {
      var e2 = [];
      if (Array.isArray(t2)) e2 = t2;
      else if (typeof t2.length == "number") for (var i2 = 0; i2 < t2.length; i2++) e2.push(t2[i2]);
      else e2.push(t2);
      return e2;
    }
    function o(t2, e2, r2) {
      return this instanceof o
        ? (typeof t2 == "string" && (t2 = document.querySelectorAll(t2)),
          (this.elements = n(t2)),
          (this.options = i({}, this.options)),
          typeof e2 == "function" ? (r2 = e2) : i(this.options, e2),
          r2 && this.on("always", r2),
          this.getImages(),
          h && (this.jqDeferred = new h.Deferred()),
          void setTimeout(
            function () {
              this.check();
            }.bind(this)
          ))
        : new o(t2, e2, r2);
    }
    function r(t2) {
      this.img = t2;
    }
    function s(t2, e2) {
      (this.url = t2), (this.element = e2), (this.img = new Image());
    }
    var h = t.jQuery,
      a = t.console;
    (o.prototype = Object.create(e.prototype)),
      (o.prototype.options = {}),
      (o.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      }),
      (o.prototype.addElementImages = function (t2) {
        t2.nodeName == "IMG" && this.addImage(t2), this.options.background === !0 && this.addElementBackgroundImages(t2);
        var e2 = t2.nodeType;
        if (e2 && d[e2]) {
          for (var i2 = t2.querySelectorAll("img"), n2 = 0; n2 < i2.length; n2++) {
            var o2 = i2[n2];
            this.addImage(o2);
          }
          if (typeof this.options.background == "string") {
            var r2 = t2.querySelectorAll(this.options.background);
            for (n2 = 0; n2 < r2.length; n2++) {
              var s2 = r2[n2];
              this.addElementBackgroundImages(s2);
            }
          }
        }
      });
    var d = { 1: !0, 9: !0, 11: !0 };
    return (
      (o.prototype.addElementBackgroundImages = function (t2) {
        var e2 = getComputedStyle(t2);
        if (e2)
          for (var i2 = /url\((['"])?(.*?)\1\)/gi, n2 = i2.exec(e2.backgroundImage); n2 !== null; ) {
            var o2 = n2 && n2[2];
            o2 && this.addBackground(o2, t2), (n2 = i2.exec(e2.backgroundImage));
          }
      }),
      (o.prototype.addImage = function (t2) {
        var e2 = new r(t2);
        this.images.push(e2);
      }),
      (o.prototype.addBackground = function (t2, e2) {
        var i2 = new s(t2, e2);
        this.images.push(i2);
      }),
      (o.prototype.check = function () {
        function t2(t3, i2, n2) {
          setTimeout(function () {
            e2.progress(t3, i2, n2);
          });
        }
        var e2 = this;
        return (
          (this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? void this.images.forEach(function (e3) {
                e3.once("progress", t2), e3.check();
              })
            : void this.complete()
        );
      }),
      (o.prototype.progress = function (t2, e2, i2) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !t2.isLoaded),
          this.emitEvent("progress", [this, t2, e2]),
          this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t2),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && a && a.log("progress: " + i2, t2, e2);
      }),
      (o.prototype.complete = function () {
        var t2 = this.hasAnyBroken ? "fail" : "done";
        if (((this.isComplete = !0), this.emitEvent(t2, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
          var e2 = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[e2](this);
        }
      }),
      (r.prototype = Object.create(e.prototype)),
      (r.prototype.check = function () {
        var t2 = this.getIsImageComplete();
        return t2
          ? void this.confirm(this.img.naturalWidth !== 0, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            void (this.proxyImage.src = this.img.src));
      }),
      (r.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth !== void 0;
      }),
      (r.prototype.confirm = function (t2, e2) {
        (this.isLoaded = t2), this.emitEvent("progress", [this, this.img, e2]);
      }),
      (r.prototype.handleEvent = function (t2) {
        var e2 = "on" + t2.type;
        this[e2] && this[e2](t2);
      }),
      (r.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (r.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (r.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
      }),
      (s.prototype = Object.create(r.prototype)),
      (s.prototype.check = function () {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url);
        var t2 = this.getIsImageComplete();
        t2 && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"), this.unbindEvents());
      }),
      (s.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
      }),
      (s.prototype.confirm = function (t2, e2) {
        (this.isLoaded = t2), this.emitEvent("progress", [this, this.element, e2]);
      }),
      (o.makeJQueryPlugin = function (e2) {
        (e2 = e2 || t.jQuery),
          e2 &&
            ((h = e2),
            (h.fn.imagesLoaded = function (t2, e3) {
              var i2 = new o(this, t2, e3);
              return i2.jqDeferred.promise(h(this));
            }));
      }),
      o.makeJQueryPlugin(),
      o
    );
  }),
  (function ($2) {
    var e = !0;
    ($2.flexslider = function (t, a) {
      var n = $2(t);
      a.rtl === void 0 && $2("html").attr("dir") == "rtl" && (a.rtl = !0), (n.vars = $2.extend({}, $2.flexslider.defaults, a));
      var i = n.vars.namespace,
        r = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
        s = ("ontouchstart" in window || r || (window.DocumentTouch && document instanceof DocumentTouch)) && n.vars.touch,
        o = "click touchend MSPointerUp keyup",
        l = "",
        c,
        d = n.vars.direction === "vertical",
        u = n.vars.reverse,
        v = n.vars.itemWidth > 0,
        p = n.vars.animation === "fade",
        m = n.vars.asNavFor !== "",
        f = {};
      $2.data(t, "flexslider", n),
        (f = {
          init: function () {
            (n.animating = !1),
              (n.currentSlide = parseInt(n.vars.startAt ? n.vars.startAt : 0, 10)),
              isNaN(n.currentSlide) && (n.currentSlide = 0),
              (n.animatingTo = n.currentSlide),
              (n.atEnd = n.currentSlide === 0 || n.currentSlide === n.last),
              (n.containerSelector = n.vars.selector.substr(0, n.vars.selector.search(" "))),
              (n.slides = $2(n.vars.selector, n)),
              (n.container = $2(n.containerSelector, n)),
              (n.count = n.slides.length),
              (n.syncExists = $2(n.vars.sync).length > 0),
              n.vars.animation === "slide" && (n.vars.animation = "swing"),
              (n.prop = d ? "top" : n.vars.rtl ? "marginRight" : "marginLeft"),
              (n.args = {}),
              (n.manualPause = !1),
              (n.stopped = !1),
              (n.started = !1),
              (n.startTimeout = null),
              (n.transitions =
                !n.vars.video &&
                !p &&
                n.vars.useCSS &&
                (function () {
                  var e2 = document.createElement("div"),
                    t2 = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                  for (var a2 in t2) if (e2.style[t2[a2]] !== void 0) return (n.pfx = t2[a2].replace("Perspective", "").toLowerCase()), (n.prop = "-" + n.pfx + "-transform"), !0;
                  return !1;
                })()),
              (n.isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1),
              (n.ensureAnimationEnd = ""),
              n.vars.controlsContainer !== "" && (n.controlsContainer = $2(n.vars.controlsContainer).length > 0 && $2(n.vars.controlsContainer)),
              n.vars.manualControls !== "" && (n.manualControls = $2(n.vars.manualControls).length > 0 && $2(n.vars.manualControls)),
              n.vars.customDirectionNav !== "" && (n.customDirectionNav = $2(n.vars.customDirectionNav).length === 2 && $2(n.vars.customDirectionNav)),
              n.vars.randomize &&
                (n.slides.sort(function () {
                  return Math.round(Math.random()) - 0.5;
                }),
                n.container.empty().append(n.slides)),
              n.doMath(),
              n.setup("init"),
              n.vars.controlNav && f.controlNav.setup(),
              n.vars.directionNav && f.directionNav.setup(),
              n.vars.keyboard &&
                ($2(n.containerSelector).length === 1 || n.vars.multipleKeyboard) &&
                $2(document).bind("keyup", function (e2) {
                  var t2 = e2.keyCode;
                  if (!n.animating && (t2 === 39 || t2 === 37)) {
                    var a2 = n.vars.rtl ? (t2 === 37 ? n.getTarget("next") : t2 === 39 && n.getTarget("prev")) : t2 === 39 ? n.getTarget("next") : t2 === 37 && n.getTarget("prev");
                    n.flexAnimate(a2, n.vars.pauseOnAction);
                  }
                }),
              n.vars.mousewheel &&
                n.bind("mousewheel", function (e2, t2, a2, i2) {
                  e2.preventDefault();
                  var r2 = t2 < 0 ? n.getTarget("next") : n.getTarget("prev");
                  n.flexAnimate(r2, n.vars.pauseOnAction);
                }),
              n.vars.pausePlay && f.pausePlay.setup(),
              n.vars.slideshow && n.vars.pauseInvisible && f.pauseInvisible.init(),
              n.vars.slideshow &&
                (n.vars.pauseOnHover &&
                  n.hover(
                    function () {
                      n.manualPlay || n.manualPause || n.pause();
                    },
                    function () {
                      n.manualPause || n.manualPlay || n.stopped || n.play();
                    }
                  ),
                (n.vars.pauseInvisible && f.pauseInvisible.isHidden()) || (n.vars.initDelay > 0 ? (n.startTimeout = setTimeout(n.play, n.vars.initDelay)) : n.play())),
              m && f.asNav.setup(),
              s && n.vars.touch && f.touch(),
              (!p || (p && n.vars.smoothHeight)) && $2(window).bind("resize orientationchange focus", f.resize),
              n.find("img").attr("draggable", "false"),
              setTimeout(function () {
                n.vars.start(n);
              }, 200);
          },
          asNav: {
            setup: function () {
              (n.asNav = !0),
                (n.animatingTo = Math.floor(n.currentSlide / n.move)),
                (n.currentItem = n.currentSlide),
                n.slides
                  .removeClass(i + "active-slide")
                  .eq(n.currentItem)
                  .addClass(i + "active-slide"),
                r
                  ? ((t._slider = n),
                    n.slides.each(function () {
                      var e2 = this;
                      (e2._gesture = new MSGesture()),
                        (e2._gesture.target = e2),
                        e2.addEventListener(
                          "MSPointerDown",
                          function (e3) {
                            e3.preventDefault(), e3.currentTarget._gesture && e3.currentTarget._gesture.addPointer(e3.pointerId);
                          },
                          !1
                        ),
                        e2.addEventListener("MSGestureTap", function (e3) {
                          e3.preventDefault();
                          var t2 = $2(this),
                            a2 = t2.index();
                          $2(n.vars.asNavFor).data("flexslider").animating || t2.hasClass("active") || ((n.direction = n.currentItem < a2 ? "next" : "prev"), n.flexAnimate(a2, n.vars.pauseOnAction, !1, !0, !0));
                        });
                    }))
                  : n.slides.on(o, function (e2) {
                      e2.preventDefault();
                      var t2 = $2(this),
                        a2 = t2.index(),
                        r2;
                      (r2 = n.vars.rtl ? -1 * (t2.offset().right - $2(n).scrollLeft()) : t2.offset().left - $2(n).scrollLeft()),
                        r2 <= 0 && t2.hasClass(i + "active-slide")
                          ? n.flexAnimate(n.getTarget("prev"), !0)
                          : $2(n.vars.asNavFor).data("flexslider").animating || t2.hasClass(i + "active-slide") || ((n.direction = n.currentItem < a2 ? "next" : "prev"), n.flexAnimate(a2, n.vars.pauseOnAction, !1, !0, !0));
                    });
            },
          },
          controlNav: {
            setup: function () {
              n.manualControls ? f.controlNav.setupManual() : f.controlNav.setupPaging();
            },
            setupPaging: function () {
              var e2 = n.vars.controlNav === "thumbnails" ? "control-thumbs" : "control-paging",
                t2 = 1,
                a2,
                r2;
              if (((n.controlNavScaffold = $2('<ol class="' + i + "control-nav " + i + e2 + '"></ol>')), n.pagingCount > 1))
                for (var s2 = 0; s2 < n.pagingCount; s2++) {
                  (r2 = n.slides.eq(s2)), r2.attr("data-thumb-alt") === void 0 && r2.attr("data-thumb-alt", "");
                  var c2 = r2.attr("data-thumb-alt") !== "" ? (c2 = ' alt="' + r2.attr("data-thumb-alt") + '"') : "";
                  if (((a2 = n.vars.controlNav === "thumbnails" ? '<img src="' + r2.attr("data-thumb") + '"' + c2 + "/>" : '<a href="#">' + t2 + "</a>"), n.vars.controlNav === "thumbnails" && n.vars.thumbCaptions === !0)) {
                    var d2 = r2.attr("data-thumbcaption");
                    d2 !== "" && d2 !== void 0 && (a2 += '<span class="' + i + 'caption">' + d2 + "</span>");
                  }
                  n.controlNavScaffold.append("<li>" + a2 + "</li>"), t2++;
                }
              n.controlsContainer ? $2(n.controlsContainer).append(n.controlNavScaffold) : n.append(n.controlNavScaffold),
                f.controlNav.set(),
                f.controlNav.active(),
                n.controlNavScaffold.delegate("a, img", o, function (e3) {
                  if ((e3.preventDefault(), l === "" || l === e3.type)) {
                    var t3 = $2(this),
                      a3 = n.controlNav.index(t3);
                    t3.hasClass(i + "active") || ((n.direction = a3 > n.currentSlide ? "next" : "prev"), n.flexAnimate(a3, n.vars.pauseOnAction));
                  }
                  l === "" && (l = e3.type), f.setToClearWatchedEvent();
                });
            },
            setupManual: function () {
              (n.controlNav = n.manualControls),
                f.controlNav.active(),
                n.controlNav.bind(o, function (e2) {
                  if ((e2.preventDefault(), l === "" || l === e2.type)) {
                    var t2 = $2(this),
                      a2 = n.controlNav.index(t2);
                    t2.hasClass(i + "active") || (a2 > n.currentSlide ? (n.direction = "next") : (n.direction = "prev"), n.flexAnimate(a2, n.vars.pauseOnAction));
                  }
                  l === "" && (l = e2.type), f.setToClearWatchedEvent();
                });
            },
            set: function () {
              var e2 = n.vars.controlNav === "thumbnails" ? "img" : "a";
              n.controlNav = $2("." + i + "control-nav li " + e2, n.controlsContainer ? n.controlsContainer : n);
            },
            active: function () {
              n.controlNav
                .removeClass(i + "active")
                .eq(n.animatingTo)
                .addClass(i + "active");
            },
            update: function (e2, t2) {
              n.pagingCount > 1 && e2 === "add" ? n.controlNavScaffold.append($2('<li><a href="#">' + n.count + "</a></li>")) : n.pagingCount === 1 ? n.controlNavScaffold.find("li").remove() : n.controlNav.eq(t2).closest("li").remove(),
                f.controlNav.set(),
                n.pagingCount > 1 && n.pagingCount !== n.controlNav.length ? n.update(t2, e2) : f.controlNav.active();
            },
          },
          directionNav: {
            setup: function () {
              var e2 = $2(
                '<ul class="' +
                  i +
                  'direction-nav"><li class="' +
                  i +
                  'nav-prev"><a class="' +
                  i +
                  'prev" href="#">' +
                  n.vars.prevText +
                  '</a></li><li class="' +
                  i +
                  'nav-next"><a class="' +
                  i +
                  'next" href="#">' +
                  n.vars.nextText +
                  "</a></li></ul>"
              );
              n.customDirectionNav
                ? (n.directionNav = n.customDirectionNav)
                : n.controlsContainer
                ? ($2(n.controlsContainer).append(e2), (n.directionNav = $2("." + i + "direction-nav li a", n.controlsContainer)))
                : (n.append(e2), (n.directionNav = $2("." + i + "direction-nav li a", n))),
                f.directionNav.update(),
                n.directionNav.bind(o, function (e3) {
                  e3.preventDefault();
                  var t2;
                  (l !== "" && l !== e3.type) || ((t2 = $2(this).hasClass(i + "next") ? n.getTarget("next") : n.getTarget("prev")), n.flexAnimate(t2, n.vars.pauseOnAction)), l === "" && (l = e3.type), f.setToClearWatchedEvent();
                });
            },
            update: function () {
              var e2 = i + "disabled";
              n.pagingCount === 1
                ? n.directionNav.addClass(e2).attr("tabindex", "-1")
                : n.vars.animationLoop
                ? n.directionNav.removeClass(e2).removeAttr("tabindex")
                : n.animatingTo === 0
                ? n.directionNav
                    .removeClass(e2)
                    .filter("." + i + "prev")
                    .addClass(e2)
                    .attr("tabindex", "-1")
                : n.animatingTo === n.last
                ? n.directionNav
                    .removeClass(e2)
                    .filter("." + i + "next")
                    .addClass(e2)
                    .attr("tabindex", "-1")
                : n.directionNav.removeClass(e2).removeAttr("tabindex");
            },
          },
          pausePlay: {
            setup: function () {
              var e2 = $2('<div class="' + i + 'pauseplay"><a href="#"></a></div>');
              n.controlsContainer ? (n.controlsContainer.append(e2), (n.pausePlay = $2("." + i + "pauseplay a", n.controlsContainer))) : (n.append(e2), (n.pausePlay = $2("." + i + "pauseplay a", n))),
                f.pausePlay.update(n.vars.slideshow ? i + "pause" : i + "play"),
                n.pausePlay.bind(o, function (e3) {
                  e3.preventDefault(),
                    (l !== "" && l !== e3.type) || ($2(this).hasClass(i + "pause") ? ((n.manualPause = !0), (n.manualPlay = !1), n.pause()) : ((n.manualPause = !1), (n.manualPlay = !0), n.play())),
                    l === "" && (l = e3.type),
                    f.setToClearWatchedEvent();
                });
            },
            update: function (e2) {
              e2 === "play"
                ? n.pausePlay
                    .removeClass(i + "pause")
                    .addClass(i + "play")
                    .html(n.vars.playText)
                : n.pausePlay
                    .removeClass(i + "play")
                    .addClass(i + "pause")
                    .html(n.vars.pauseText);
            },
          },
          touch: function () {
            function e2(e3) {
              e3.stopPropagation(),
                n.animating
                  ? e3.preventDefault()
                  : (n.pause(),
                    t._gesture.addPointer(e3.pointerId),
                    (w = 0),
                    (c2 = d ? n.h : n.w),
                    (f2 = Number(new Date())),
                    (l2 =
                      v && u && n.animatingTo === n.last
                        ? 0
                        : v && u
                        ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                        : v && n.currentSlide === n.last
                        ? n.limit
                        : v
                        ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                        : u
                        ? (n.last - n.currentSlide + n.cloneOffset) * c2
                        : (n.currentSlide + n.cloneOffset) * c2));
            }
            function a2(e3) {
              e3.stopPropagation();
              var a3 = e3.target._slider;
              if (a3) {
                var n2 = -e3.translationX,
                  i3 = -e3.translationY;
                if (((w += d ? i3 : n2), (m2 = (a3.vars.rtl ? -1 : 1) * w), (x2 = d ? Math.abs(w) < Math.abs(-n2) : Math.abs(w) < Math.abs(-i3)), e3.detail === e3.MSGESTURE_FLAG_INERTIA))
                  return void setImmediate(function () {
                    t._gesture.stop();
                  });
                (!x2 || Number(new Date()) - f2 > 500) &&
                  (e3.preventDefault(),
                  !p && a3.transitions && (a3.vars.animationLoop || (m2 = w / ((a3.currentSlide === 0 && w < 0) || (a3.currentSlide === a3.last && w > 0) ? Math.abs(w) / c2 + 2 : 1)), a3.setProps(l2 + m2, "setTouch")));
              }
            }
            function i2(e3) {
              e3.stopPropagation();
              var t2 = e3.target._slider;
              if (t2) {
                if (t2.animatingTo === t2.currentSlide && !x2 && m2 !== null) {
                  var a3 = u ? -m2 : m2,
                    n2 = a3 > 0 ? t2.getTarget("next") : t2.getTarget("prev");
                  t2.canAdvance(n2) && ((Number(new Date()) - f2 < 550 && Math.abs(a3) > 50) || Math.abs(a3) > c2 / 2) ? t2.flexAnimate(n2, t2.vars.pauseOnAction) : p || t2.flexAnimate(t2.currentSlide, t2.vars.pauseOnAction, !0);
                }
                (s2 = null), (o2 = null), (m2 = null), (l2 = null), (w = 0);
              }
            }
            var s2,
              o2,
              l2,
              c2,
              m2,
              f2,
              g,
              h,
              S,
              x2 = !1,
              y = 0,
              b = 0,
              w = 0;
            r
              ? ((t.style.msTouchAction = "none"),
                (t._gesture = new MSGesture()),
                (t._gesture.target = t),
                t.addEventListener("MSPointerDown", e2, !1),
                (t._slider = n),
                t.addEventListener("MSGestureChange", a2, !1),
                t.addEventListener("MSGestureEnd", i2, !1))
              : ((g = function (e3) {
                  n.animating
                    ? e3.preventDefault()
                    : (window.navigator.msPointerEnabled || e3.touches.length === 1) &&
                      (n.pause(),
                      (c2 = d ? n.h : n.w),
                      (f2 = Number(new Date())),
                      (y = e3.touches[0].pageX),
                      (b = e3.touches[0].pageY),
                      (l2 =
                        v && u && n.animatingTo === n.last
                          ? 0
                          : v && u
                          ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                          : v && n.currentSlide === n.last
                          ? n.limit
                          : v
                          ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                          : u
                          ? (n.last - n.currentSlide + n.cloneOffset) * c2
                          : (n.currentSlide + n.cloneOffset) * c2),
                      (s2 = d ? b : y),
                      (o2 = d ? y : b),
                      t.addEventListener("touchmove", h, !1),
                      t.addEventListener("touchend", S, !1));
                }),
                (h = function (e3) {
                  (y = e3.touches[0].pageX), (b = e3.touches[0].pageY), (m2 = d ? s2 - b : (n.vars.rtl ? -1 : 1) * (s2 - y)), (x2 = d ? Math.abs(m2) < Math.abs(y - o2) : Math.abs(m2) < Math.abs(b - o2));
                  var t2 = 500;
                  (!x2 || Number(new Date()) - f2 > 500) &&
                    (e3.preventDefault(), !p && n.transitions && (n.vars.animationLoop || (m2 /= (n.currentSlide === 0 && m2 < 0) || (n.currentSlide === n.last && m2 > 0) ? Math.abs(m2) / c2 + 2 : 1), n.setProps(l2 + m2, "setTouch")));
                }),
                (S = function (e3) {
                  if ((t.removeEventListener("touchmove", h, !1), n.animatingTo === n.currentSlide && !x2 && m2 !== null)) {
                    var a3 = u ? -m2 : m2,
                      i3 = a3 > 0 ? n.getTarget("next") : n.getTarget("prev");
                    n.canAdvance(i3) && ((Number(new Date()) - f2 < 550 && Math.abs(a3) > 50) || Math.abs(a3) > c2 / 2) ? n.flexAnimate(i3, n.vars.pauseOnAction) : p || n.flexAnimate(n.currentSlide, n.vars.pauseOnAction, !0);
                  }
                  t.removeEventListener("touchend", S, !1), (s2 = null), (o2 = null), (m2 = null), (l2 = null);
                }),
                t.addEventListener("touchstart", g, !1));
          },
          resize: function () {
            !n.animating &&
              n.is(":visible") &&
              (v || n.doMath(),
              p
                ? f.smoothHeight()
                : v
                ? (n.slides.width(n.computedW), n.update(n.pagingCount), n.setProps())
                : d
                ? (n.viewport.height(n.h), n.setProps(n.h, "setTotal"))
                : (n.vars.smoothHeight && f.smoothHeight(), n.newSlides.width(n.computedW), n.setProps(n.computedW, "setTotal")));
          },
          smoothHeight: function (e2) {
            if (!d || p) {
              var t2 = p ? n : n.viewport;
              e2 ? t2.animate({ height: n.slides.eq(n.animatingTo).innerHeight() }, e2) : t2.innerHeight(n.slides.eq(n.animatingTo).innerHeight());
            }
          },
          sync: function (e2) {
            var t2 = $2(n.vars.sync).data("flexslider"),
              a2 = n.animatingTo;
            switch (e2) {
              case "animate":
                t2.flexAnimate(a2, n.vars.pauseOnAction, !1, !0);
                break;
              case "play":
                t2.playing || t2.asNav || t2.play();
                break;
              case "pause":
                t2.pause();
                break;
            }
          },
          uniqueID: function (e2) {
            return (
              e2
                .filter("[id]")
                .add(e2.find("[id]"))
                .each(function () {
                  var e3 = $2(this);
                  e3.attr("id", e3.attr("id") + "_clone");
                }),
              e2
            );
          },
          pauseInvisible: {
            visProp: null,
            init: function () {
              var e2 = f.pauseInvisible.getHiddenProp();
              if (e2) {
                var t2 = e2.replace(/[H|h]idden/, "") + "visibilitychange";
                document.addEventListener(t2, function () {
                  f.pauseInvisible.isHidden() ? (n.startTimeout ? clearTimeout(n.startTimeout) : n.pause()) : n.started ? n.play() : n.vars.initDelay > 0 ? setTimeout(n.play, n.vars.initDelay) : n.play();
                });
              }
            },
            isHidden: function () {
              var e2 = f.pauseInvisible.getHiddenProp();
              return !!e2 && document[e2];
            },
            getHiddenProp: function () {
              var e2 = ["webkit", "moz", "ms", "o"];
              if ("hidden" in document) return "hidden";
              for (var t2 = 0; t2 < e2.length; t2++) if (e2[t2] + "Hidden" in document) return e2[t2] + "Hidden";
              return null;
            },
          },
          setToClearWatchedEvent: function () {
            clearTimeout(c),
              (c = setTimeout(function () {
                l = "";
              }, 3e3));
          },
        }),
        (n.flexAnimate = function (e2, t2, a2, r2, o2) {
          if (
            (n.vars.animationLoop || e2 === n.currentSlide || (n.direction = e2 > n.currentSlide ? "next" : "prev"),
            m && n.pagingCount === 1 && (n.direction = n.currentItem < e2 ? "next" : "prev"),
            !n.animating && (n.canAdvance(e2, o2) || a2) && n.is(":visible"))
          ) {
            if (m && r2) {
              var l2 = $2(n.vars.asNavFor).data("flexslider");
              if (
                ((n.atEnd = e2 === 0 || e2 === n.count - 1),
                l2.flexAnimate(e2, !0, !1, !0, o2),
                (n.direction = n.currentItem < e2 ? "next" : "prev"),
                (l2.direction = n.direction),
                Math.ceil((e2 + 1) / n.visible) - 1 === n.currentSlide || e2 === 0)
              )
                return (
                  (n.currentItem = e2),
                  n.slides
                    .removeClass(i + "active-slide")
                    .eq(e2)
                    .addClass(i + "active-slide"),
                  !1
                );
              (n.currentItem = e2),
                n.slides
                  .removeClass(i + "active-slide")
                  .eq(e2)
                  .addClass(i + "active-slide"),
                (e2 = Math.floor(e2 / n.visible));
            }
            if (
              ((n.animating = !0),
              (n.animatingTo = e2),
              t2 && n.pause(),
              n.vars.before(n),
              n.syncExists && !o2 && f.sync("animate"),
              n.vars.controlNav && f.controlNav.active(),
              v ||
                n.slides
                  .removeClass(i + "active-slide")
                  .eq(e2)
                  .addClass(i + "active-slide"),
              (n.atEnd = e2 === 0 || e2 === n.last),
              n.vars.directionNav && f.directionNav.update(),
              e2 === n.last && (n.vars.end(n), n.vars.animationLoop || n.pause()),
              p)
            )
              s
                ? (n.slides.eq(n.currentSlide).css({ opacity: 0, zIndex: 1 }), n.slides.eq(e2).css({ opacity: 1, zIndex: 2 }), n.wrapup(c2))
                : (n.slides.eq(n.currentSlide).css({ zIndex: 1 }).animate({ opacity: 0 }, n.vars.animationSpeed, n.vars.easing), n.slides.eq(e2).css({ zIndex: 2 }).animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing, n.wrapup));
            else {
              var c2 = d ? n.slides.filter(":first").height() : n.computedW,
                g,
                h,
                S;
              v
                ? ((g = n.vars.itemMargin), (S = (n.itemW + g) * n.move * n.animatingTo), (h = S > n.limit && n.visible !== 1 ? n.limit : S))
                : (h =
                    n.currentSlide === 0 && e2 === n.count - 1 && n.vars.animationLoop && n.direction !== "next"
                      ? u
                        ? (n.count + n.cloneOffset) * c2
                        : 0
                      : n.currentSlide === n.last && e2 === 0 && n.vars.animationLoop && n.direction !== "prev"
                      ? u
                        ? 0
                        : (n.count + 1) * c2
                      : u
                      ? (n.count - 1 - e2 + n.cloneOffset) * c2
                      : (e2 + n.cloneOffset) * c2),
                n.setProps(h, "", n.vars.animationSpeed),
                n.transitions
                  ? ((n.vars.animationLoop && n.atEnd) || ((n.animating = !1), (n.currentSlide = n.animatingTo)),
                    n.container.unbind("webkitTransitionEnd transitionend"),
                    n.container.bind("webkitTransitionEnd transitionend", function () {
                      clearTimeout(n.ensureAnimationEnd), n.wrapup(c2);
                    }),
                    clearTimeout(n.ensureAnimationEnd),
                    (n.ensureAnimationEnd = setTimeout(function () {
                      n.wrapup(c2);
                    }, n.vars.animationSpeed + 100)))
                  : n.container.animate(n.args, n.vars.animationSpeed, n.vars.easing, function () {
                      n.wrapup(c2);
                    });
            }
            n.vars.smoothHeight && f.smoothHeight(n.vars.animationSpeed);
          }
        }),
        (n.wrapup = function (e2) {
          p || v || (n.currentSlide === 0 && n.animatingTo === n.last && n.vars.animationLoop ? n.setProps(e2, "jumpEnd") : n.currentSlide === n.last && n.animatingTo === 0 && n.vars.animationLoop && n.setProps(e2, "jumpStart")),
            (n.animating = !1),
            (n.currentSlide = n.animatingTo),
            n.vars.after(n);
        }),
        (n.animateSlides = function () {
          !n.animating && e && n.flexAnimate(n.getTarget("next"));
        }),
        (n.pause = function () {
          clearInterval(n.animatedSlides), (n.animatedSlides = null), (n.playing = !1), n.vars.pausePlay && f.pausePlay.update("play"), n.syncExists && f.sync("pause");
        }),
        (n.play = function () {
          n.playing && clearInterval(n.animatedSlides),
            (n.animatedSlides = n.animatedSlides || setInterval(n.animateSlides, n.vars.slideshowSpeed)),
            (n.started = n.playing = !0),
            n.vars.pausePlay && f.pausePlay.update("pause"),
            n.syncExists && f.sync("play");
        }),
        (n.stop = function () {
          n.pause(), (n.stopped = !0);
        }),
        (n.canAdvance = function (e2, t2) {
          var a2 = m ? n.pagingCount - 1 : n.last;
          return (
            !!t2 ||
            !(!m || n.currentItem !== n.count - 1 || e2 !== 0 || n.direction !== "prev") ||
            ((!m || n.currentItem !== 0 || e2 !== n.pagingCount - 1 || n.direction === "next") &&
              !(e2 === n.currentSlide && !m) &&
              (!!n.vars.animationLoop || ((!n.atEnd || n.currentSlide !== 0 || e2 !== a2 || n.direction === "next") && (!n.atEnd || n.currentSlide !== a2 || e2 !== 0 || n.direction !== "next"))))
          );
        }),
        (n.getTarget = function (e2) {
          return (n.direction = e2), e2 === "next" ? (n.currentSlide === n.last ? 0 : n.currentSlide + 1) : n.currentSlide === 0 ? n.last : n.currentSlide - 1;
        }),
        (n.setProps = function (e2, t2, a2) {
          var i2 = (function () {
            var a3 = e2 || (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo;
            return (
              (function () {
                if (v) return t2 === "setTouch" ? e2 : u && n.animatingTo === n.last ? 0 : u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : n.animatingTo === n.last ? n.limit : a3;
                switch (t2) {
                  case "setTotal":
                    return u ? (n.count - 1 - n.currentSlide + n.cloneOffset) * e2 : (n.currentSlide + n.cloneOffset) * e2;
                  case "setTouch":
                    return e2;
                  case "jumpEnd":
                    return u ? e2 : n.count * e2;
                  case "jumpStart":
                    return u ? n.count * e2 : e2;
                  default:
                    return e2;
                }
              })() *
                (n.vars.rtl ? 1 : -1) +
              "px"
            );
          })();
          n.transitions &&
            ((i2 = n.isFirefox ? (d ? "translate3d(0," + i2 + ",0)" : "translate3d(" + parseInt(i2) + "px,0,0)") : d ? "translate3d(0," + i2 + ",0)" : "translate3d(" + (n.vars.rtl ? -1 : 1) * parseInt(i2) + "px,0,0)"),
            (a2 = a2 !== void 0 ? a2 / 1e3 + "s" : "0s"),
            n.container.css("-" + n.pfx + "-transition-duration", a2),
            n.container.css("transition-duration", a2)),
            (n.args[n.prop] = i2),
            (n.transitions || a2 === void 0) && n.container.css(n.args),
            n.container.css("transform", i2);
        }),
        (n.setup = function (e2) {
          if (p)
            n.vars.rtl ? n.slides.css({ width: "100%", float: "right", marginLeft: "-100%", position: "relative" }) : n.slides.css({ width: "100%", float: "left", marginRight: "-100%", position: "relative" }),
              e2 === "init" &&
                (s
                  ? n.slides
                      .css({ opacity: 0, display: "block", webkitTransition: "opacity " + n.vars.animationSpeed / 1e3 + "s ease", zIndex: 1 })
                      .eq(n.currentSlide)
                      .css({ opacity: 1, zIndex: 2 })
                  : n.vars.fadeFirstSlide == 0
                  ? n.slides.css({ opacity: 0, display: "block", zIndex: 1 }).eq(n.currentSlide).css({ zIndex: 2 }).css({ opacity: 1 })
                  : n.slides.css({ opacity: 0, display: "block", zIndex: 1 }).eq(n.currentSlide).css({ zIndex: 2 }).animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing)),
              n.vars.smoothHeight && f.smoothHeight();
          else {
            var t2, a2;
            e2 === "init" &&
              ((n.viewport = $2('<div class="' + i + 'viewport"></div>')
                .css({ overflow: "hidden", position: "relative" })
                .appendTo(n)
                .append(n.container)),
              (n.cloneCount = 0),
              (n.cloneOffset = 0),
              u && ((a2 = $2.makeArray(n.slides).reverse()), (n.slides = $2(a2)), n.container.empty().append(n.slides))),
              n.vars.animationLoop &&
                !v &&
                ((n.cloneCount = 2),
                (n.cloneOffset = 1),
                e2 !== "init" && n.container.find(".clone").remove(),
                n.container.append(f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"))),
              (n.newSlides = $2(n.vars.selector, n)),
              (t2 = u ? n.count - 1 - n.currentSlide + n.cloneOffset : n.currentSlide + n.cloneOffset),
              d && !v
                ? (n.container
                    .height(200 * (n.count + n.cloneCount) + "%")
                    .css("position", "absolute")
                    .width("100%"),
                  setTimeout(
                    function () {
                      n.newSlides.css({ display: "block" }), n.doMath(), n.viewport.height(n.h), n.setProps(t2 * n.h, "init");
                    },
                    e2 === "init" ? 100 : 0
                  ))
                : (n.container.width(200 * (n.count + n.cloneCount) + "%"),
                  n.setProps(t2 * n.computedW, "init"),
                  setTimeout(
                    function () {
                      n.doMath(),
                        n.vars.rtl && n.isFirefox
                          ? n.newSlides.css({ width: n.computedW, marginRight: n.computedM, float: "right", display: "block" })
                          : n.newSlides.css({ width: n.computedW, marginRight: n.computedM, float: "left", display: "block" }),
                        n.vars.smoothHeight && f.smoothHeight();
                    },
                    e2 === "init" ? 100 : 0
                  ));
          }
          v ||
            n.slides
              .removeClass(i + "active-slide")
              .eq(n.currentSlide)
              .addClass(i + "active-slide"),
            n.vars.init(n);
        }),
        (n.doMath = function () {
          var e2 = n.slides.first(),
            t2 = n.vars.itemMargin,
            a2 = n.vars.minItems,
            i2 = n.vars.maxItems;
          (n.w = n.viewport === void 0 ? n.width() : n.viewport.width()),
            n.isFirefox && (n.w = n.width()),
            (n.h = e2.height()),
            (n.boxPadding = e2.outerWidth() - e2.width()),
            v
              ? ((n.itemT = n.vars.itemWidth + t2),
                (n.itemM = t2),
                (n.minW = a2 ? a2 * n.itemT : n.w),
                (n.maxW = i2 ? i2 * n.itemT - t2 : n.w),
                (n.itemW = n.minW > n.w ? (n.w - t2 * (a2 - 1)) / a2 : n.maxW < n.w ? (n.w - t2 * (i2 - 1)) / i2 : n.vars.itemWidth > n.w ? n.w : n.vars.itemWidth),
                (n.visible = Math.floor(n.w / n.itemW)),
                (n.move = n.vars.move > 0 && n.vars.move < n.visible ? n.vars.move : n.visible),
                (n.pagingCount = Math.ceil((n.count - n.visible) / n.move + 1)),
                (n.last = n.pagingCount - 1),
                (n.limit = n.pagingCount === 1 ? 0 : n.vars.itemWidth > n.w ? n.itemW * (n.count - 1) + t2 * (n.count - 1) : (n.itemW + t2) * n.count - n.w - t2))
              : ((n.itemW = n.w), (n.itemM = t2), (n.pagingCount = n.count), (n.last = n.count - 1)),
            (n.computedW = n.itemW - n.boxPadding),
            (n.computedM = n.itemM);
        }),
        (n.update = function (e2, t2) {
          n.doMath(),
            v || (e2 < n.currentSlide ? (n.currentSlide += 1) : e2 <= n.currentSlide && e2 !== 0 && (n.currentSlide -= 1), (n.animatingTo = n.currentSlide)),
            n.vars.controlNav &&
              !n.manualControls &&
              ((t2 === "add" && !v) || n.pagingCount > n.controlNav.length
                ? f.controlNav.update("add")
                : ((t2 === "remove" && !v) || n.pagingCount < n.controlNav.length) && (v && n.currentSlide > n.last && ((n.currentSlide -= 1), (n.animatingTo -= 1)), f.controlNav.update("remove", n.last))),
            n.vars.directionNav && f.directionNav.update();
        }),
        (n.addSlide = function (e2, t2) {
          var a2 = $2(e2);
          (n.count += 1),
            (n.last = n.count - 1),
            d && u ? (t2 !== void 0 ? n.slides.eq(n.count - t2).after(a2) : n.container.prepend(a2)) : t2 !== void 0 ? n.slides.eq(t2).before(a2) : n.container.append(a2),
            n.update(t2, "add"),
            (n.slides = $2(n.vars.selector + ":not(.clone)", n)),
            n.setup(),
            n.vars.added(n);
        }),
        (n.removeSlide = function (e2) {
          var t2 = isNaN(e2) ? n.slides.index($2(e2)) : e2;
          (n.count -= 1),
            (n.last = n.count - 1),
            isNaN(e2) ? $2(e2, n.slides).remove() : d && u ? n.slides.eq(n.last).remove() : n.slides.eq(e2).remove(),
            n.doMath(),
            n.update(t2, "remove"),
            (n.slides = $2(n.vars.selector + ":not(.clone)", n)),
            n.setup(),
            n.vars.removed(n);
        }),
        f.init();
    }),
      $2(window)
        .blur(function (t) {
          e = !1;
        })
        .focus(function (t) {
          e = !0;
        }),
      ($2.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: !1,
        animationLoop: !0,
        smoothHeight: !1,
        startAt: 0,
        slideshow: !0,
        slideshowSpeed: 7e3,
        animationSpeed: 600,
        initDelay: 0,
        randomize: !1,
        fadeFirstSlide: !0,
        thumbCaptions: !1,
        pauseOnAction: !0,
        pauseOnHover: !1,
        pauseInvisible: !0,
        useCSS: !0,
        touch: !0,
        video: !1,
        controlNav: !0,
        directionNav: !0,
        prevText: "Previous",
        nextText: "Next",
        keyboard: !0,
        multipleKeyboard: !1,
        mousewheel: !1,
        pausePlay: !1,
        pauseText: "Pause",
        playText: "Play",
        controlsContainer: "",
        manualControls: "",
        customDirectionNav: "",
        sync: "",
        asNavFor: "",
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: !0,
        isFirefox: !1,
        start: function () {},
        before: function () {},
        after: function () {},
        end: function () {},
        added: function () {},
        removed: function () {},
        init: function () {},
        rtl: !1,
      }),
      ($2.fn.flexslider = function (e2) {
        if ((e2 === void 0 && (e2 = {}), typeof e2 == "object"))
          return this.each(function () {
            var t2 = $2(this),
              a = e2.selector ? e2.selector : ".slides > li",
              n = t2.find(a);
            (n.length === 1 && e2.allowOneSlide === !1) || n.length === 0 ? (n.fadeIn(400), e2.start && e2.start(t2)) : t2.data("flexslider") === void 0 && new $2.flexslider(this, e2);
          });
        var t = $2(this).data("flexslider");
        switch (e2) {
          case "play":
            t.play();
            break;
          case "pause":
            t.pause();
            break;
          case "stop":
            t.stop();
            break;
          case "next":
            t.flexAnimate(t.getTarget("next"), !0);
            break;
          case "prev":
          case "previous":
            t.flexAnimate(t.getTarget("prev"), !0);
            break;
          default:
            typeof e2 == "number" && t.flexAnimate(e2, !0);
        }
      });
  })(jQuery);
/*!
	Zoom v1.7.13 - 2014-04-29
	Enlarge images on click or mouseover.
	(c) 2014 Jack Moore - http://www.jacklmoore.com/zoom
	license: http://www.opensource.org/licenses/mit-license.php
*/ (function (o) {
  var t = { url: !1, callback: !1, target: !1, duration: 120, on: "mouseover", touch: !0, onZoomIn: !1, onZoomOut: !1, magnify: 1 };
  (o.zoom = function (t2, n, e, i) {
    var u,
      c,
      a,
      m,
      l,
      r,
      s,
      f = o(t2).css("position"),
      h = o(n);
    return (
      (t2.style.position = /(absolute|fixed)/.test(f) ? f : "relative"),
      (t2.style.overflow = "hidden"),
      (e.style.width = e.style.height = ""),
      o(e)
        .addClass("zoomImg")
        .css({ position: "absolute", top: 0, left: 0, opacity: 0, width: e.width * i, height: e.height * i, border: "none", maxWidth: "none", maxHeight: "none" })
        .appendTo(t2),
      {
        init: function () {
          (c = o(t2).outerWidth()), (u = o(t2).outerHeight()), n === t2 ? ((m = c), (a = u)) : ((m = h.outerWidth()), (a = h.outerHeight())), (l = (e.width - c) / m), (r = (e.height - u) / a), (s = h.offset());
        },
        move: function (o2) {
          var t3 = o2.pageX - s.left,
            n2 = o2.pageY - s.top;
          (n2 = Math.max(Math.min(n2, a), 0)), (t3 = Math.max(Math.min(t3, m), 0)), (e.style.left = t3 * -l + "px"), (e.style.top = n2 * -r + "px");
        },
      }
    );
  }),
    (o.fn.zoom = function (n) {
      return this.each(function () {
        var e,
          i = o.extend({}, t, n || {}),
          u = i.target || this,
          c = this,
          a = o(c),
          m = document.createElement("img"),
          l = o(m),
          r = "mousemove.zoom",
          s = !1,
          f = !1;
        (i.url || ((e = a.find("img")), e[0] && (i.url = e.data("src") || e.attr("src")), i.url)) &&
          ((function () {
            var o2 = u.style.position,
              t2 = u.style.overflow;
            a.one("zoom.destroy", function () {
              a.off(".zoom"), (u.style.position = o2), (u.style.overflow = t2), l.remove();
            });
          })(),
          (m.onload = function () {
            function t2(t3) {
              e2.init(), e2.move(t3), l.stop().fadeTo(o.support.opacity ? i.duration : 0, 1, o.isFunction(i.onZoomIn) ? i.onZoomIn.call(m) : !1);
            }
            function n2() {
              l.stop().fadeTo(i.duration, 0, o.isFunction(i.onZoomOut) ? i.onZoomOut.call(m) : !1);
            }
            var e2 = o.zoom(u, c, m, i.magnify);
            i.on === "grab"
              ? a.on("mousedown.zoom", function (i2) {
                  i2.which === 1 &&
                    (o(document).one("mouseup.zoom", function () {
                      n2(), o(document).off(r, e2.move);
                    }),
                    t2(i2),
                    o(document).on(r, e2.move),
                    i2.preventDefault());
                })
              : i.on === "click"
              ? a.on("click.zoom", function (i2) {
                  return s
                    ? void 0
                    : ((s = !0),
                      t2(i2),
                      o(document).on(r, e2.move),
                      o(document).one("click.zoom", function () {
                        n2(), (s = !1), o(document).off(r, e2.move);
                      }),
                      !1);
                })
              : i.on === "toggle"
              ? a.on("click.zoom", function (o2) {
                  s ? n2() : t2(o2), (s = !s);
                })
              : i.on === "mouseover" && (e2.init(), a.on("mouseenter.zoom", t2).on("mouseleave.zoom", n2).on(r, e2.move)),
              i.touch &&
                a
                  .on("touchstart.zoom", function (o2) {
                    o2.preventDefault(), f ? ((f = !1), n2()) : ((f = !0), t2(o2.originalEvent.touches[0] || o2.originalEvent.changedTouches[0]));
                  })
                  .on("touchmove.zoom", function (o2) {
                    o2.preventDefault(), e2.move(o2.originalEvent.touches[0] || o2.originalEvent.changedTouches[0]);
                  }),
              o.isFunction(i.callback) && i.callback.call(m);
          }),
          (m.src = i.url));
      });
    }),
    (o.fn.zoom.defaults = t);
})(window.jQuery);
/*! Magnific Popup - v1.0.0 - 2015-03-30
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2015 Dmitry Semenov; */ (function (a) {
  typeof define == "function" && define.amd ? define(["jquery"], a) : a(typeof exports == "object" ? require("jquery") : window.jQuery || window.Zepto);
})(function (a) {
  var b,
    c,
    d,
    e,
    f,
    g,
    h = "Close",
    i = "BeforeClose",
    j = "AfterClose",
    k = "BeforeAppend",
    l = "MarkupParse",
    m = "Open",
    n = "Change",
    o = "mfp",
    p = "." + o,
    q = "mfp-ready",
    r = "mfp-removing",
    s = "mfp-prevent-close",
    t = function () {},
    u = !!window.jQuery,
    v = a(window),
    w = function (a2, c2) {
      b.ev.on(o + a2 + p, c2);
    },
    x2 = function (b2, c2, d2, e2) {
      var f2 = document.createElement("div");
      return (f2.className = "mfp-" + b2), d2 && (f2.innerHTML = d2), e2 ? c2 && c2.appendChild(f2) : ((f2 = a(f2)), c2 && f2.appendTo(c2)), f2;
    },
    y = function (c2, d2) {
      b.ev.triggerHandler(o + c2, d2), b.st.callbacks && ((c2 = c2.charAt(0).toLowerCase() + c2.slice(1)), b.st.callbacks[c2] && b.st.callbacks[c2].apply(b, a.isArray(d2) ? d2 : [d2]));
    },
    z = function (c2) {
      return (c2 === g && b.currTemplate.closeBtn) || ((b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose))), (g = c2)), b.currTemplate.closeBtn;
    },
    A = function () {
      a.magnificPopup.instance || ((b = new t()), b.init(), (a.magnificPopup.instance = b));
    },
    B = function () {
      var a2 = document.createElement("p").style,
        b2 = ["ms", "O", "Moz", "Webkit"];
      if (a2.transition !== void 0) return !0;
      for (; b2.length; ) if (b2.pop() + "Transition" in a2) return !0;
      return !1;
    };
  (t.prototype = {
    constructor: t,
    init: function () {
      var c2 = navigator.appVersion;
      (b.isIE7 = c2.indexOf("MSIE 7.") !== -1),
        (b.isIE8 = c2.indexOf("MSIE 8.") !== -1),
        (b.isLowIE = b.isIE7 || b.isIE8),
        (b.isAndroid = /android/gi.test(c2)),
        (b.isIOS = /iphone|ipad|ipod/gi.test(c2)),
        (b.supportsTransition = B()),
        (b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent)),
        (d = a(document)),
        (b.popupsCache = {});
    },
    open: function (c2) {
      var e2;
      if (c2.isObj === !1) {
        (b.items = c2.items.toArray()), (b.index = 0);
        var g2,
          h2 = c2.items;
        for (e2 = 0; e2 < h2.length; e2++)
          if (((g2 = h2[e2]), g2.parsed && (g2 = g2.el[0]), g2 === c2.el[0])) {
            b.index = e2;
            break;
          }
      } else (b.items = a.isArray(c2.items) ? c2.items : [c2.items]), (b.index = c2.index || 0);
      if (b.isOpen) return void b.updateItemHTML();
      (b.types = []),
        (f = ""),
        (b.ev = c2.mainEl && c2.mainEl.length ? c2.mainEl.eq(0) : d),
        c2.key ? (b.popupsCache[c2.key] || (b.popupsCache[c2.key] = {}), (b.currTemplate = b.popupsCache[c2.key])) : (b.currTemplate = {}),
        (b.st = a.extend(!0, {}, a.magnificPopup.defaults, c2)),
        (b.fixedContentPos = b.st.fixedContentPos === "auto" ? !b.probablyMobile : b.st.fixedContentPos),
        b.st.modal && ((b.st.closeOnContentClick = !1), (b.st.closeOnBgClick = !1), (b.st.showCloseBtn = !1), (b.st.enableEscapeKey = !1)),
        b.bgOverlay ||
          ((b.bgOverlay = x2("bg").on("click" + p, function () {
            b.close();
          })),
          (b.wrap = x2("wrap")
            .attr("tabindex", -1)
            .on("click" + p, function (a2) {
              b._checkIfClose(a2.target) && b.close();
            })),
          (b.container = x2("container", b.wrap))),
        (b.contentContainer = x2("content")),
        b.st.preloader && (b.preloader = x2("preloader", b.container, b.st.tLoading));
      var i2 = a.magnificPopup.modules;
      for (e2 = 0; e2 < i2.length; e2++) {
        var j2 = i2[e2];
        (j2 = j2.charAt(0).toUpperCase() + j2.slice(1)), b["init" + j2].call(b);
      }
      y("BeforeOpen"),
        b.st.showCloseBtn &&
          (b.st.closeBtnInside
            ? (w(l, function (a2, b2, c3, d2) {
                c3.close_replaceWith = z(d2.type);
              }),
              (f += " mfp-close-btn-in"))
            : b.wrap.append(z())),
        b.st.alignTop && (f += " mfp-align-top"),
        b.wrap.css(b.fixedContentPos ? { overflow: b.st.overflowY, overflowX: "hidden", overflowY: b.st.overflowY } : { top: v.scrollTop(), position: "absolute" }),
        (b.st.fixedBgPos === !1 || (b.st.fixedBgPos === "auto" && !b.fixedContentPos)) && b.bgOverlay.css({ height: d.height(), position: "absolute" }),
        b.st.enableEscapeKey &&
          d.on("keyup" + p, function (a2) {
            a2.keyCode === 27 && b.close();
          }),
        v.on("resize" + p, function () {
          b.updateSize();
        }),
        b.st.closeOnContentClick || (f += " mfp-auto-cursor"),
        f && b.wrap.addClass(f);
      var k2 = (b.wH = v.height()),
        n2 = {};
      if (b.fixedContentPos && b._hasScrollBar(k2)) {
        var o2 = b._getScrollbarSize();
        o2 && (n2.marginRight = o2);
      }
      b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : (n2.overflow = "hidden"));
      var r2 = b.st.mainClass;
      return (
        b.isIE7 && (r2 += " mfp-ie7"),
        r2 && b._addClassToMFP(r2),
        b.updateItemHTML(),
        y("BuildControls"),
        a("html").css(n2),
        b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)),
        (b._lastFocusedEl = document.activeElement),
        setTimeout(function () {
          b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn);
        }, 16),
        (b.isOpen = !0),
        b.updateSize(k2),
        y(m),
        c2
      );
    },
    close: function () {
      b.isOpen &&
        (y(i),
        (b.isOpen = !1),
        b.st.removalDelay && !b.isLowIE && b.supportsTransition
          ? (b._addClassToMFP(r),
            setTimeout(function () {
              b._close();
            }, b.st.removalDelay))
          : b._close());
    },
    _close: function () {
      y(h);
      var c2 = r + " " + q + " ";
      if ((b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c2 += b.st.mainClass + " "), b._removeClassFromMFP(c2), b.fixedContentPos)) {
        var e2 = { marginRight: "" };
        b.isIE7 ? a("body, html").css("overflow", "") : (e2.overflow = ""), a("html").css(e2);
      }
      d.off("keyup" + p + " focusin" + p),
        b.ev.off(p),
        b.wrap.attr("class", "mfp-wrap").removeAttr("style"),
        b.bgOverlay.attr("class", "mfp-bg"),
        b.container.attr("class", "mfp-container"),
        !b.st.showCloseBtn || (b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0) || (b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach()),
        b._lastFocusedEl && a(b._lastFocusedEl).focus(),
        (b.currItem = null),
        (b.content = null),
        (b.currTemplate = null),
        (b.prevHeight = 0),
        y(j);
    },
    updateSize: function (a2) {
      if (b.isIOS) {
        var c2 = document.documentElement.clientWidth / window.innerWidth,
          d2 = window.innerHeight * c2;
        b.wrap.css("height", d2), (b.wH = d2);
      } else b.wH = a2 || v.height();
      b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize");
    },
    updateItemHTML: function () {
      var c2 = b.items[b.index];
      b.contentContainer.detach(), b.content && b.content.detach(), c2.parsed || (c2 = b.parseEl(b.index));
      var d2 = c2.type;
      if ((y("BeforeChange", [b.currItem ? b.currItem.type : "", d2]), (b.currItem = c2), !b.currTemplate[d2])) {
        var f2 = b.st[d2] ? b.st[d2].markup : !1;
        y("FirstMarkupParse", f2), (b.currTemplate[d2] = f2 ? a(f2) : !0);
      }
      e && e !== c2.type && b.container.removeClass("mfp-" + e + "-holder");
      var g2 = b["get" + d2.charAt(0).toUpperCase() + d2.slice(1)](c2, b.currTemplate[d2]);
      b.appendContent(g2, d2), (c2.preloaded = !0), y(n, c2), (e = c2.type), b.container.prepend(b.contentContainer), y("AfterChange");
    },
    appendContent: function (a2, c2) {
      (b.content = a2),
        a2 ? (b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c2] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : (b.content = a2)) : (b.content = ""),
        y(k),
        b.container.addClass("mfp-" + c2 + "-holder"),
        b.contentContainer.append(b.content);
    },
    parseEl: function (c2) {
      var d2,
        e2 = b.items[c2];
      if ((e2.tagName ? (e2 = { el: a(e2) }) : ((d2 = e2.type), (e2 = { data: e2, src: e2.src })), e2.el)) {
        for (var f2 = b.types, g2 = 0; g2 < f2.length; g2++)
          if (e2.el.hasClass("mfp-" + f2[g2])) {
            d2 = f2[g2];
            break;
          }
        (e2.src = e2.el.attr("data-mfp-src")), e2.src || (e2.src = e2.el.attr("href"));
      }
      return (e2.type = d2 || b.st.type || "inline"), (e2.index = c2), (e2.parsed = !0), (b.items[c2] = e2), y("ElementParse", e2), b.items[c2];
    },
    addGroup: function (a2, c2) {
      var d2 = function (d3) {
        (d3.mfpEl = this), b._openClick(d3, a2, c2);
      };
      c2 || (c2 = {});
      var e2 = "click.magnificPopup";
      (c2.mainEl = a2), c2.items ? ((c2.isObj = !0), a2.off(e2).on(e2, d2)) : ((c2.isObj = !1), c2.delegate ? a2.off(e2).on(e2, c2.delegate, d2) : ((c2.items = a2), a2.off(e2).on(e2, d2)));
    },
    _openClick: function (c2, d2, e2) {
      var f2 = e2.midClick !== void 0 ? e2.midClick : a.magnificPopup.defaults.midClick;
      if (f2 || (c2.which !== 2 && !c2.ctrlKey && !c2.metaKey)) {
        var g2 = e2.disableOn !== void 0 ? e2.disableOn : a.magnificPopup.defaults.disableOn;
        if (g2) {
          if (a.isFunction(g2)) {
            if (!g2.call(b)) return !0;
          } else if (v.width() < g2) return !0;
        }
        c2.type && (c2.preventDefault(), b.isOpen && c2.stopPropagation()), (e2.el = a(c2.mfpEl)), e2.delegate && (e2.items = d2.find(e2.delegate)), b.open(e2);
      }
    },
    updateStatus: function (a2, d2) {
      if (b.preloader) {
        c !== a2 && b.container.removeClass("mfp-s-" + c), d2 || a2 !== "loading" || (d2 = b.st.tLoading);
        var e2 = { status: a2, text: d2 };
        y("UpdateStatus", e2),
          (a2 = e2.status),
          (d2 = e2.text),
          b.preloader.html(d2),
          b.preloader.find("a").on("click", function (a3) {
            a3.stopImmediatePropagation();
          }),
          b.container.addClass("mfp-s-" + a2),
          (c = a2);
      }
    },
    _checkIfClose: function (c2) {
      if (!a(c2).hasClass(s)) {
        var d2 = b.st.closeOnContentClick,
          e2 = b.st.closeOnBgClick;
        if ((d2 && e2) || !b.content || a(c2).hasClass("mfp-close") || (b.preloader && c2 === b.preloader[0])) return !0;
        if (c2 === b.content[0] || a.contains(b.content[0], c2)) {
          if (d2) return !0;
        } else if (e2 && a.contains(document, c2)) return !0;
        return !1;
      }
    },
    _addClassToMFP: function (a2) {
      b.bgOverlay.addClass(a2), b.wrap.addClass(a2);
    },
    _removeClassFromMFP: function (a2) {
      this.bgOverlay.removeClass(a2), b.wrap.removeClass(a2);
    },
    _hasScrollBar: function (a2) {
      return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a2 || v.height());
    },
    _setFocus: function () {
      (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();
    },
    _onFocusIn: function (c2) {
      return c2.target === b.wrap[0] || a.contains(b.wrap[0], c2.target) ? void 0 : (b._setFocus(), !1);
    },
    _parseMarkup: function (b2, c2, d2) {
      var e2;
      d2.data && (c2 = a.extend(d2.data, c2)),
        y(l, [b2, c2, d2]),
        a.each(c2, function (a2, c3) {
          if (c3 === void 0 || c3 === !1) return !0;
          if (((e2 = a2.split("_")), e2.length > 1)) {
            var d3 = b2.find(p + "-" + e2[0]);
            if (d3.length > 0) {
              var f2 = e2[1];
              f2 === "replaceWith" ? d3[0] !== c3[0] && d3.replaceWith(c3) : f2 === "img" ? (d3.is("img") ? d3.attr("src", c3) : d3.replaceWith('<img src="' + c3 + '" class="' + d3.attr("class") + '" />')) : d3.attr(e2[1], c3);
            }
          } else b2.find(p + "-" + a2).html(c3);
        });
    },
    _getScrollbarSize: function () {
      if (b.scrollbarSize === void 0) {
        var a2 = document.createElement("div");
        (a2.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"), document.body.appendChild(a2), (b.scrollbarSize = a2.offsetWidth - a2.clientWidth), document.body.removeChild(a2);
      }
      return b.scrollbarSize;
    },
  }),
    (a.magnificPopup = {
      instance: null,
      proto: t.prototype,
      modules: [],
      open: function (b2, c2) {
        return A(), (b2 = b2 ? a.extend(!0, {}, b2) : {}), (b2.isObj = !0), (b2.index = c2 || 0), this.instance.open(b2);
      },
      close: function () {
        return a.magnificPopup.instance && a.magnificPopup.instance.close();
      },
      registerModule: function (b2, c2) {
        c2.options && (a.magnificPopup.defaults[b2] = c2.options), a.extend(this.proto, c2.proto), this.modules.push(b2);
      },
      defaults: {
        disableOn: 0,
        key: null,
        midClick: !1,
        mainClass: "",
        preloader: !0,
        focus: "",
        closeOnContentClick: !1,
        closeOnBgClick: !0,
        closeBtnInside: !0,
        showCloseBtn: !0,
        enableEscapeKey: !0,
        modal: !1,
        alignTop: !1,
        removalDelay: 0,
        prependTo: null,
        fixedContentPos: "auto",
        fixedBgPos: "auto",
        overflowY: "auto",
        closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
        tClose: "Close (Esc)",
        tLoading: "Loading...",
      },
    }),
    (a.fn.magnificPopup = function (c2) {
      A();
      var d2 = a(this);
      if (typeof c2 == "string")
        if (c2 === "open") {
          var e2,
            f2 = u ? d2.data("magnificPopup") : d2[0].magnificPopup,
            g2 = parseInt(arguments[1], 10) || 0;
          f2.items ? (e2 = f2.items[g2]) : ((e2 = d2), f2.delegate && (e2 = e2.find(f2.delegate)), (e2 = e2.eq(g2))), b._openClick({ mfpEl: e2 }, d2, f2);
        } else b.isOpen && b[c2].apply(b, Array.prototype.slice.call(arguments, 1));
      else (c2 = a.extend(!0, {}, c2)), u ? d2.data("magnificPopup", c2) : (d2[0].magnificPopup = c2), b.addGroup(d2, c2);
      return d2;
    });
  var C,
    D,
    E,
    F = "inline",
    G = function () {
      E && (D.after(E.addClass(C)).detach(), (E = null));
    };
  a.magnificPopup.registerModule(F, {
    options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" },
    proto: {
      initInline: function () {
        b.types.push(F),
          w(h + "." + F, function () {
            G();
          });
      },
      getInline: function (c2, d2) {
        if ((G(), c2.src)) {
          var e2 = b.st.inline,
            f2 = a(c2.src);
          if (f2.length) {
            var g2 = f2[0].parentNode;
            g2 && g2.tagName && (D || ((C = e2.hiddenClass), (D = x2(C)), (C = "mfp-" + C)), (E = f2.after(D).detach().removeClass(C))), b.updateStatus("ready");
          } else b.updateStatus("error", e2.tNotFound), (f2 = a("<div>"));
          return (c2.inlineElement = f2), f2;
        }
        return b.updateStatus("ready"), b._parseMarkup(d2, {}, c2), d2;
      },
    },
  });
  var H,
    I = "ajax",
    J = function () {
      H && a(document.body).removeClass(H);
    },
    K = function () {
      J(), b.req && b.req.abort();
    };
  a.magnificPopup.registerModule(I, {
    options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' },
    proto: {
      initAjax: function () {
        b.types.push(I), (H = b.st.ajax.cursor), w(h + "." + I, K), w("BeforeChange." + I, K);
      },
      getAjax: function (c2) {
        H && a(document.body).addClass(H), b.updateStatus("loading");
        var d2 = a.extend(
          {
            url: c2.src,
            success: function (d3, e2, f2) {
              var g2 = { data: d3, xhr: f2 };
              y("ParseAjax", g2),
                b.appendContent(a(g2.data), I),
                (c2.finished = !0),
                J(),
                b._setFocus(),
                setTimeout(function () {
                  b.wrap.addClass(q);
                }, 16),
                b.updateStatus("ready"),
                y("AjaxContentAdded");
            },
            error: function () {
              J(), (c2.finished = c2.loadError = !0), b.updateStatus("error", b.st.ajax.tError.replace("%url%", c2.src));
            },
          },
          b.st.ajax.settings
        );
        return (b.req = a.ajax(d2)), "";
      },
    },
  });
  var L,
    M = function (c2) {
      if (c2.data && c2.data.title !== void 0) return c2.data.title;
      var d2 = b.st.image.titleSrc;
      if (d2) {
        if (a.isFunction(d2)) return d2.call(b, c2);
        if (c2.el) return c2.el.attr(d2) || "";
      }
      return "";
    };
  a.magnificPopup.registerModule("image", {
    options: {
      markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
      cursor: "mfp-zoom-out-cur",
      titleSrc: "title",
      verticalFit: !0,
      tError: '<a href="%url%">The image</a> could not be loaded.',
    },
    proto: {
      initImage: function () {
        var c2 = b.st.image,
          d2 = ".image";
        b.types.push("image"),
          w(m + d2, function () {
            b.currItem.type === "image" && c2.cursor && a(document.body).addClass(c2.cursor);
          }),
          w(h + d2, function () {
            c2.cursor && a(document.body).removeClass(c2.cursor), v.off("resize" + p);
          }),
          w("Resize" + d2, b.resizeImage),
          b.isLowIE && w("AfterChange", b.resizeImage);
      },
      resizeImage: function () {
        var a2 = b.currItem;
        if (a2 && a2.img && b.st.image.verticalFit) {
          var c2 = 0;
          b.isLowIE && (c2 = parseInt(a2.img.css("padding-top"), 10) + parseInt(a2.img.css("padding-bottom"), 10)), a2.img.css("max-height", b.wH - c2);
        }
      },
      _onImageHasSize: function (a2) {
        a2.img && ((a2.hasSize = !0), L && clearInterval(L), (a2.isCheckingImgSize = !1), y("ImageHasSize", a2), a2.imgHidden && (b.content && b.content.removeClass("mfp-loading"), (a2.imgHidden = !1)));
      },
      findImageSize: function (a2) {
        var c2 = 0,
          d2 = a2.img[0],
          e2 = function (f2) {
            L && clearInterval(L),
              (L = setInterval(function () {
                return d2.naturalWidth > 0 ? void b._onImageHasSize(a2) : (c2 > 200 && clearInterval(L), c2++, void (c2 === 3 ? e2(10) : c2 === 40 ? e2(50) : c2 === 100 && e2(500)));
              }, f2));
          };
        e2(1);
      },
      getImage: function (c2, d2) {
        var e2 = 0,
          f2 = function () {
            c2 &&
              (c2.img[0].complete
                ? (c2.img.off(".mfploader"), c2 === b.currItem && (b._onImageHasSize(c2), b.updateStatus("ready")), (c2.hasSize = !0), (c2.loaded = !0), y("ImageLoadComplete"))
                : (e2++, 200 > e2 ? setTimeout(f2, 100) : g2()));
          },
          g2 = function () {
            c2 && (c2.img.off(".mfploader"), c2 === b.currItem && (b._onImageHasSize(c2), b.updateStatus("error", h2.tError.replace("%url%", c2.src))), (c2.hasSize = !0), (c2.loaded = !0), (c2.loadError = !0));
          },
          h2 = b.st.image,
          i2 = d2.find(".mfp-img");
        if (i2.length) {
          var j2 = document.createElement("img");
          (j2.className = "mfp-img"),
            c2.el && c2.el.find("img").length && (j2.alt = c2.el.find("img").attr("alt")),
            (c2.img = a(j2).on("load.mfploader", f2).on("error.mfploader", g2)),
            (j2.src = c2.src),
            i2.is("img") && (c2.img = c2.img.clone()),
            (j2 = c2.img[0]),
            j2.naturalWidth > 0 ? (c2.hasSize = !0) : j2.width || (c2.hasSize = !1);
        }
        return (
          b._parseMarkup(d2, { title: M(c2), img_replaceWith: c2.img }, c2),
          b.resizeImage(),
          c2.hasSize
            ? (L && clearInterval(L), c2.loadError ? (d2.addClass("mfp-loading"), b.updateStatus("error", h2.tError.replace("%url%", c2.src))) : (d2.removeClass("mfp-loading"), b.updateStatus("ready")), d2)
            : (b.updateStatus("loading"), (c2.loading = !0), c2.hasSize || ((c2.imgHidden = !0), d2.addClass("mfp-loading"), b.findImageSize(c2)), d2)
        );
      },
    },
  });
  var N,
    O = function () {
      return N === void 0 && (N = document.createElement("p").style.MozTransform !== void 0), N;
    };
  a.magnificPopup.registerModule("zoom", {
    options: {
      enabled: !1,
      easing: "ease-in-out",
      duration: 300,
      opener: function (a2) {
        return a2.is("img") ? a2 : a2.find("img");
      },
    },
    proto: {
      initZoom: function () {
        var a2,
          c2 = b.st.zoom,
          d2 = ".zoom";
        if (c2.enabled && b.supportsTransition) {
          var e2,
            f2,
            g2 = c2.duration,
            j2 = function (a3) {
              var b2 = a3.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                d3 = "all " + c2.duration / 1e3 + "s " + c2.easing,
                e3 = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" },
                f3 = "transition";
              return (e3["-webkit-" + f3] = e3["-moz-" + f3] = e3["-o-" + f3] = e3[f3] = d3), b2.css(e3), b2;
            },
            k2 = function () {
              b.content.css("visibility", "visible");
            };
          w("BuildControls" + d2, function () {
            if (b._allowZoom()) {
              if ((clearTimeout(e2), b.content.css("visibility", "hidden"), (a2 = b._getItemToZoom()), !a2)) return void k2();
              (f2 = j2(a2)),
                f2.css(b._getOffset()),
                b.wrap.append(f2),
                (e2 = setTimeout(function () {
                  f2.css(b._getOffset(!0)),
                    (e2 = setTimeout(function () {
                      k2(),
                        setTimeout(function () {
                          f2.remove(), (a2 = f2 = null), y("ZoomAnimationEnded");
                        }, 16);
                    }, g2));
                }, 16));
            }
          }),
            w(i + d2, function () {
              if (b._allowZoom()) {
                if ((clearTimeout(e2), (b.st.removalDelay = g2), !a2)) {
                  if (((a2 = b._getItemToZoom()), !a2)) return;
                  f2 = j2(a2);
                }
                f2.css(b._getOffset(!0)),
                  b.wrap.append(f2),
                  b.content.css("visibility", "hidden"),
                  setTimeout(function () {
                    f2.css(b._getOffset());
                  }, 16);
              }
            }),
            w(h + d2, function () {
              b._allowZoom() && (k2(), f2 && f2.remove(), (a2 = null));
            });
        }
      },
      _allowZoom: function () {
        return b.currItem.type === "image";
      },
      _getItemToZoom: function () {
        return b.currItem.hasSize ? b.currItem.img : !1;
      },
      _getOffset: function (c2) {
        var d2;
        d2 = c2 ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
        var e2 = d2.offset(),
          f2 = parseInt(d2.css("padding-top"), 10),
          g2 = parseInt(d2.css("padding-bottom"), 10);
        e2.top -= a(window).scrollTop() - f2;
        var h2 = { width: d2.width(), height: (u ? d2.innerHeight() : d2[0].offsetHeight) - g2 - f2 };
        return O() ? (h2["-moz-transform"] = h2.transform = "translate(" + e2.left + "px," + e2.top + "px)") : ((h2.left = e2.left), (h2.top = e2.top)), h2;
      },
    },
  });
  var P = "iframe",
    Q = "//about:blank",
    R = function (a2) {
      if (b.currTemplate[P]) {
        var c2 = b.currTemplate[P].find("iframe");
        c2.length && (a2 || (c2[0].src = Q), b.isIE8 && c2.css("display", a2 ? "block" : "none"));
      }
    };
  a.magnificPopup.registerModule(P, {
    options: {
      markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
      srcAction: "iframe_src",
      patterns: {
        youtube: { index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" },
        vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" },
        gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
      },
    },
    proto: {
      initIframe: function () {
        b.types.push(P),
          w("BeforeChange", function (a2, b2, c2) {
            b2 !== c2 && (b2 === P ? R() : c2 === P && R(!0));
          }),
          w(h + "." + P, function () {
            R();
          });
      },
      getIframe: function (c2, d2) {
        var e2 = c2.src,
          f2 = b.st.iframe;
        a.each(f2.patterns, function () {
          return e2.indexOf(this.index) > -1 ? (this.id && (e2 = typeof this.id == "string" ? e2.substr(e2.lastIndexOf(this.id) + this.id.length, e2.length) : this.id.call(this, e2)), (e2 = this.src.replace("%id%", e2)), !1) : void 0;
        });
        var g2 = {};
        return f2.srcAction && (g2[f2.srcAction] = e2), b._parseMarkup(d2, g2, c2), b.updateStatus("ready"), d2;
      },
    },
  });
  var S = function (a2) {
      var c2 = b.items.length;
      return a2 > c2 - 1 ? a2 - c2 : 0 > a2 ? c2 + a2 : a2;
    },
    T = function (a2, b2, c2) {
      return a2.replace(/%curr%/gi, b2 + 1).replace(/%total%/gi, c2);
    };
  a.magnificPopup.registerModule("gallery", {
    options: {
      enabled: !1,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: !0,
      arrows: !0,
      tPrev: "Previous (Left arrow key)",
      tNext: "Next (Right arrow key)",
      tCounter: "%curr% of %total%",
    },
    proto: {
      initGallery: function () {
        var c2 = b.st.gallery,
          e2 = ".mfp-gallery",
          g2 = !!a.fn.mfpFastClick;
        return (
          (b.direction = !0),
          c2 && c2.enabled
            ? ((f += " mfp-gallery"),
              w(m + e2, function () {
                c2.navigateByImgClick &&
                  b.wrap.on("click" + e2, ".mfp-img", function () {
                    return b.items.length > 1 ? (b.next(), !1) : void 0;
                  }),
                  d.on("keydown" + e2, function (a2) {
                    a2.keyCode === 37 ? b.prev() : a2.keyCode === 39 && b.next();
                  });
              }),
              w("UpdateStatus" + e2, function (a2, c3) {
                c3.text && (c3.text = T(c3.text, b.currItem.index, b.items.length));
              }),
              w(l + e2, function (a2, d2, e3, f2) {
                var g3 = b.items.length;
                e3.counter = g3 > 1 ? T(c2.tCounter, f2.index, g3) : "";
              }),
              w("BuildControls" + e2, function () {
                if (b.items.length > 1 && c2.arrows && !b.arrowLeft) {
                  var d2 = c2.arrowMarkup,
                    e3 = (b.arrowLeft = a(d2.replace(/%title%/gi, c2.tPrev).replace(/%dir%/gi, "left")).addClass(s)),
                    f2 = (b.arrowRight = a(d2.replace(/%title%/gi, c2.tNext).replace(/%dir%/gi, "right")).addClass(s)),
                    h2 = g2 ? "mfpFastClick" : "click";
                  e3[h2](function () {
                    b.prev();
                  }),
                    f2[h2](function () {
                      b.next();
                    }),
                    b.isIE7 && (x2("b", e3[0], !1, !0), x2("a", e3[0], !1, !0), x2("b", f2[0], !1, !0), x2("a", f2[0], !1, !0)),
                    b.container.append(e3.add(f2));
                }
              }),
              w(n + e2, function () {
                b._preloadTimeout && clearTimeout(b._preloadTimeout),
                  (b._preloadTimeout = setTimeout(function () {
                    b.preloadNearbyImages(), (b._preloadTimeout = null);
                  }, 16));
              }),
              void w(h + e2, function () {
                d.off(e2), b.wrap.off("click" + e2), b.arrowLeft && g2 && b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(), (b.arrowRight = b.arrowLeft = null);
              }))
            : !1
        );
      },
      next: function () {
        (b.direction = !0), (b.index = S(b.index + 1)), b.updateItemHTML();
      },
      prev: function () {
        (b.direction = !1), (b.index = S(b.index - 1)), b.updateItemHTML();
      },
      goTo: function (a2) {
        (b.direction = a2 >= b.index), (b.index = a2), b.updateItemHTML();
      },
      preloadNearbyImages: function () {
        var a2,
          c2 = b.st.gallery.preload,
          d2 = Math.min(c2[0], b.items.length),
          e2 = Math.min(c2[1], b.items.length);
        for (a2 = 1; a2 <= (b.direction ? e2 : d2); a2++) b._preloadItem(b.index + a2);
        for (a2 = 1; a2 <= (b.direction ? d2 : e2); a2++) b._preloadItem(b.index - a2);
      },
      _preloadItem: function (c2) {
        if (((c2 = S(c2)), !b.items[c2].preloaded)) {
          var d2 = b.items[c2];
          d2.parsed || (d2 = b.parseEl(c2)),
            y("LazyLoad", d2),
            d2.type === "image" &&
              (d2.img = a('<img class="mfp-img" />')
                .on("load.mfploader", function () {
                  d2.hasSize = !0;
                })
                .on("error.mfploader", function () {
                  (d2.hasSize = !0), (d2.loadError = !0), y("LazyLoadError", d2);
                })
                .attr("src", d2.src)),
            (d2.preloaded = !0);
        }
      },
    },
  });
  var U = "retina";
  a.magnificPopup.registerModule(U, {
    options: {
      replaceSrc: function (a2) {
        return a2.src.replace(/\.\w+$/, function (a3) {
          return "@2x" + a3;
        });
      },
      ratio: 1,
    },
    proto: {
      initRetina: function () {
        if (window.devicePixelRatio > 1) {
          var a2 = b.st.retina,
            c2 = a2.ratio;
          (c2 = isNaN(c2) ? c2() : c2),
            c2 > 1 &&
              (w("ImageHasSize." + U, function (a3, b2) {
                b2.img.css({ "max-width": b2.img[0].naturalWidth / c2, width: "100%" });
              }),
              w("ElementParse." + U, function (b2, d2) {
                d2.src = a2.replaceSrc(d2, c2);
              }));
        }
      },
    },
  }),
    (function () {
      var b2 = 1e3,
        c2 = "ontouchstart" in window,
        d2 = function () {
          v.off("touchmove" + f2 + " touchend" + f2);
        },
        e2 = "mfpFastClick",
        f2 = "." + e2;
      (a.fn.mfpFastClick = function (e3) {
        return a(this).each(function () {
          var g2,
            h2 = a(this);
          if (c2) {
            var i2, j2, k2, l2, m2, n2;
            h2.on("touchstart" + f2, function (a2) {
              (l2 = !1),
                (n2 = 1),
                (m2 = a2.originalEvent ? a2.originalEvent.touches[0] : a2.touches[0]),
                (j2 = m2.clientX),
                (k2 = m2.clientY),
                v
                  .on("touchmove" + f2, function (a3) {
                    (m2 = a3.originalEvent ? a3.originalEvent.touches : a3.touches), (n2 = m2.length), (m2 = m2[0]), (Math.abs(m2.clientX - j2) > 10 || Math.abs(m2.clientY - k2) > 10) && ((l2 = !0), d2());
                  })
                  .on("touchend" + f2, function (a3) {
                    d2(),
                      l2 ||
                        n2 > 1 ||
                        ((g2 = !0),
                        a3.preventDefault(),
                        clearTimeout(i2),
                        (i2 = setTimeout(function () {
                          g2 = !1;
                        }, b2)),
                        e3());
                  });
            });
          }
          h2.on("click" + f2, function () {
            g2 || e3();
          });
        });
      }),
        (a.fn.destroyMfpFastClick = function () {
          a(this).off("touchstart" + f2 + " click" + f2), c2 && v.off("touchmove" + f2 + " touchend" + f2);
        });
    })(),
    A();
}),
  (window.timber = window.timber || {}),
  (timber.cacheSelectors = function () {
    timber.cache = { $html: $("html"), $body: $("body"), $window: $(window), $navigation: $("#AccessibleNav") };
  }),
  (timber.init = function () {
    timber.cacheSelectors(), timber.accessibleNav(), timber.autoResponsiveElements();
  }),
  (timber.accessibleNav = function () {
    var classes = { active: "nav-hover", focus: "nav-focus", outside: "nav-outside", hasDropdown: "site-nav--has-dropdown" },
      selectors = {
        active: ".nav-hover",
        hasDropdown: ".site-nav--has-dropdown",
        dropdown: "[data-meganav-dropdown]",
        link: ".site-nav__link",
        nextLink: "> .site-nav__link",
        parentLink: '[data-meganav-type="parent"]',
        childLink: '[data-meganav-type="child"]',
      },
      $nav = timber.cache.$navigation,
      $allLinks = $nav.find(selectors.link),
      $parents = $nav.find(selectors.hasDropdown),
      $childLinks = $nav.find(selectors.childLink),
      $topLevel = $parents.find(selectors.nextLink),
      $dropdowns = $nav.find(selectors.dropdown),
      $subMenuLinks = $dropdowns.find(selectors.link);
    $parents.on("mouseenter touchstart", function (evt) {
      var $el = $(this),
        evtType = evt.type,
        $dropdowns2 = $nav.find(selectors.active);
      $el.hasClass(classes.active) || (evt.preventDefault(), evt.stopImmediatePropagation()), evtType === "touchstart" && $dropdowns2.length > 0 && hideDropdown($el), showDropdown($el);
    }),
      $childLinks.on("touchstart", function (evt) {
        evt.stopImmediatePropagation();
      }),
      $parents.on("mouseleave", function () {
        hideDropdown($(this));
      }),
      $allLinks.on("focus", function () {
        handleFocus($(this));
      }),
      $allLinks.on("blur", function () {
        removeFocus($topLevel);
      });
    function handleFocus($el) {
      var $newFocus = null,
        $previousItem = $el.parent().prev();
      $allLinks.attr("tabindex", ""), $previousItem.hasClass(classes.hasDropdown) && $previousItem.find(selectors.dropdown + " a").attr("tabindex", -1), ($newFocus = $el.parents(selectors.hasDropdown).find("> a")), addFocus($newFocus);
    }
    function showDropdown($el) {
      var $toplevel = $el.find(selectors.nextLink);
      $toplevel.attr("aria-expanded", !0),
        $el.addClass(classes.active),
        setTimeout(function () {
          timber.cache.$body.on("touchstart.MegaNav", function () {
            hideDropdowns();
          });
        }, 250);
    }
    function hideDropdown($el) {
      var $dropdowns2 = $el.parent().find(selectors.active),
        $parentLink = $dropdowns2.find(selectors.nextLink);
      $parentLink.attr("aria-expanded", !1), $dropdowns2.removeClass(classes.active), timber.cache.$body.off("touchstart.MegaNav");
    }
    function hideDropdowns() {
      var $dropdowns2 = $nav.find(selectors.active);
      $.each($dropdowns2, function () {
        hideDropdown($(this));
      });
    }
    function addFocus($el) {
      $el.addClass(classes.focus), $el.attr("aria-expanded") !== void 0 && $el.attr("aria-expanded", !0);
    }
    function removeFocus($el) {
      $el.removeClass(classes.focus), $subMenuLinks.attr("tabindex", -1), $el.attr("aria-expanded") !== void 0 && $el.attr("aria-expanded", !1);
    }
    function handleDropdownOffset($dropdowns2) {
      var viewportSize = $(window).width();
      $dropdowns2.removeClass(classes.outside),
        $.each($dropdowns2, function () {
          var $dropdown = $(this),
            dropdownOffset = $dropdown.offset().left + $dropdown.width();
          dropdownOffset > viewportSize && $dropdown.addClass(classes.outside);
        });
    }
    timber.cache.$window.load(function () {
      handleDropdownOffset($dropdowns);
    }),
      timber.cache.$window.resize(function () {
        afterResize(function () {
          handleDropdownOffset($dropdowns);
        }, 250);
      });
  }),
  (timber.autoResponsiveElements = function () {
    var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),
      $iframeReset = $iframeVideo.add("iframe#admin_bar_iframe");
    $("table").wrap('<div class="table-wrapper"></div>'),
      $iframeVideo.each(function () {
        $(this).parents(".video-wrapper").length || $(this).wrap('<div class="video-wrapper"></div>');
      }),
      $iframeReset.each(function () {
        this.src = this.src;
      });
  }),
  $(timber.init),
  (theme.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
      var $container = $(container),
        id = $container.attr("data-section-id"),
        type = $container.attr("data-section-type");
      if (((constructor = constructor || this.constructors[type]), !_.isUndefined(constructor))) {
        var instance = _.assignIn(new constructor(container), { id: id, type: type, container: container });
        this.instances.push(instance);
      }
    },
    _onSectionLoad: function (evt) {
      var container = $("[data-section-id]", evt.target)[0];
      container && this._createInstance(container);
    },
    _onSectionUnload: function (evt) {
      this.instances = _.filter(this.instances, function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
        return isEventInstance && _.isFunction(instance.onUnload) && instance.onUnload(evt), !isEventInstance;
      });
    },
    _onSelect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) && _.isFunction(instance.onSelect) && instance.onSelect(evt);
    },
    _onDeselect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) && _.isFunction(instance.onDeselect) && instance.onDeselect(evt);
    },
    _onBlockSelect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) && _.isFunction(instance.onBlockSelect) && instance.onBlockSelect(evt);
    },
    _onBlockDeselect: function (evt) {
      var instance = _.find(this.instances, function (instance2) {
        return instance2.id === evt.detail.sectionId;
      });
      !_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect) && instance.onBlockDeselect(evt);
    },
    register: function (type, constructor) {
      (this.constructors[type] = constructor),
        $("[data-section-type=" + type + "]").each(
          function (index, container) {
            this._createInstance(container, constructor);
          }.bind(this)
        );
    },
  })),
  (theme.a11y = {
    pageLinkFocus: function ($element) {
      var focusClass = "js-focus-hidden";
      $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);
      function callback() {
        $element.first().removeClass(focusClass).removeAttr("tabindex");
      }
    },
    focusHash: function () {
      var hash = window.location.hash;
      hash && document.getElementById(hash.slice(1)) && this.pageLinkFocus($(hash));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (evt) {
          this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (options) {
      var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
      options.$elementToFocus || (options.$elementToFocus = options.$container),
        options.$container.attr("tabindex", "-1"),
        options.$elementToFocus.focus(),
        $(document).on(eventName, function (evt) {
          options.$container[0] !== evt.target && !options.$container.has(evt.target).length && options.$container.focus();
        });
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
      options.$container && options.$container.length && options.$container.removeAttr("tabindex"), $(document).off(eventName);
    },
  }),
  (theme.Hero = (function () {
    theme.sliders = function (slider, sectionId) {
      if (
        ((this.$slider = $(slider)),
        (this.$sliderContainer = this.$slider.parent()),
        (this.sectionId = sectionId),
        (this.selectors = {
          slide: "[data-slider-item]",
          activeSlide: ".flex-active-slide",
          navigationButton: "[data-slider-navigation]",
          previousArrow: "[data-slider-prev]",
          pauseButton: "[data-slider-pause]",
          textContentMobile: "[data-text-mobile]",
          indicatorDotsContainer: ".flex-control-nav",
        }),
        $.extend(theme.strings, { loadSlideA11yString: this.$slider.data("slide-nav-a11y"), activeSlideA11yString: this.$slider.data("slide-nav-active-a11y") }),
        (this.sliderArgs = {
          animation: this.$slider.data("transition"),
          animationSpeed: 500,
          pauseOnHover: !0,
          keyboard: !1,
          slideshow: this.$slider.data("autoplay"),
          slideshowSpeed: this.$slider.data("speed"),
          controlNav: !0,
          directionNav: !1,
          smoothHeight: !1,
          controlsContainer: this.$sliderContainer.find("[data-slider-controls]"),
          before: function (slider2) {
            var $slider = $(slider2);
            $slider.resize(), $slider.find(this.selectors.slide).not(this.selectors.activeSlide).removeClass("slide-hide"), this.showMobileText(slider2.animatingTo);
          }.bind(this),
          start: function (slider2) {
            this.slideshowA11y(slider2);
          }.bind(this),
          after: function (slider2) {
            var $slider = $(slider2),
              $slides = $slider.find(this.selectors.slide),
              $activeSlide = $slider.find(this.selectors.activeSlide),
              $indicatorDots = this.$sliderContainer.find(this.selectors.indicatorDotsContainer + " a"),
              currentSlide = slider2.currentSlide;
            $slider.find(this.selectors.slide).not(this.selectors.activeSlide).addClass("slide-hide"),
              $slider.resize(),
              $slides.attr("aria-hidden", !0),
              $activeSlide.attr("aria-hidden", !1),
              $indicatorDots.each(function (index) {
                var $element = $(this);
                $element.attr("aria-label", slideLabel(currentSlide, index)), index === currentSlide ? $element.attr("aria-current", !0) : $element.removeAttr("aria-current");
              });
          }.bind(this),
          init: function (slider2) {
            var $slider = $(slider2),
              previousArrow = this.selectors.previousArrow;
            if (
              ($slider.find(this.selectors.activeSlide).removeClass("slide-hide"),
              this.$sliderContainer.find(this.selectors.navigationButton).on("click keyup", function (evt) {
                (evt.type === "keyup" && !(evt.keyCode === "13" || evt.keyCode === "32")) || ($(this).is(previousArrow) ? $slider.flexslider("prev") : $slider.flexslider("next"));
              }),
              this.sliderArgs.slideshow)
            ) {
              var $pauseButton = this.$sliderContainer.find(this.selectors.pauseButton),
                pausedClass = "is-paused";
              $pauseButton.on("click", function () {
                var $element = $(this),
                  isPaused = $element.hasClass(pausedClass);
                $element.toggleClass(pausedClass, !isPaused).attr({ "aria-label": isPaused ? $element.data("label-pause") : $element.data("label-play"), "aria-pressed": !isPaused }),
                  isPaused ? $slider.flexslider("play") : $slider.flexslider("pause");
              });
            }
          }.bind(this),
        }),
        (this.slideshowA11y = function (slider2) {
          var $slider = $(slider2),
            $sliderContainer = this.$sliderContainer,
            $slides = $slider.find(this.selectors.slide),
            $activeSlide = $slider.find(this.selectors.activeSlide),
            sectionId2 = this.sectionId,
            $indicatorsContainer = $sliderContainer.find(this.selectors.indicatorDotsContainer),
            $indicatorDots = $indicatorsContainer.find("a");
          $sliderContainer
            .on("keyup", this.keyboardNavigation.bind(this))
            .on("focusin", function (evt) {
              ($(this).has(evt.target).length && $slider.attr("aria-live") === "polite") || $slider.attr("aria-live", "polite");
            })
            .on("focusout", function (evt) {
              $(this).has(evt.relatedTarget).length || $slider.removeAttr("aria-live");
            }),
            $slides.each(function () {
              $(this).attr("aria-hidden", !0);
            }),
            $activeSlide.attr("aria-hidden", !1),
            $indicatorsContainer.off("click touchend MSPointerUp keyup", "a, img"),
            $indicatorDots.each(function (index) {
              var $element = $(this);
              $element.attr({ "aria-label": slideLabel(0, index), "data-slide-number": index + 1, "aria-controls": "slide--" + sectionId2 + "-" + index, href: "#flexslider--" + sectionId2 }).on("keyup click", function (evt) {
                if (!(evt.type === "keyup" && (evt.which === 9 && evt.stopImmediatePropagation(), evt.which !== 13))) {
                  evt.preventDefault();
                  var slideNumber = $(evt.target).data("slide-number") - 1;
                  $slider.flexslider(slideNumber), (evt.type === "keyup" || evt.detail === 0) && $sliderContainer.focus();
                }
              }),
                index === 0 && $element.attr("aria-current", !0);
            });
        }),
        (this.showMobileText = function (slideIndex) {
          var $allTextContent = this.$sliderContainer.find(this.selectors.textContentMobile),
            $currentTextContent = $allTextContent.filter("[data-mobile-slide-text=" + slideIndex + "]");
          $allTextContent.hide(), $currentTextContent.show();
        }),
        (this.keyboardNavigation = function (evt) {
          evt.keyCode === 37 && this.$slider.flexslider("prev"), evt.keyCode === 39 && this.$slider.flexslider("next");
        }),
        this.$slider.length)
      ) {
        this.$slider.find("li").length === 1 && ((this.sliderArgs.slideshow = !1), (this.sliderArgs.slideshowSpeed = 0), (this.sliderArgs.controlNav = !1), (this.sliderArgs.directionNav = !1), (this.sliderArgs.touch = !1));
        var slideshow = this.$slider.flexslider(this.sliderArgs);
        return this.showMobileText(0), slideshow;
      }
    };
    function slideLabel(activeSlideIndex, currentIndex) {
      var label = activeSlideIndex === currentIndex ? theme.strings.activeSlideA11yString : theme.strings.loadSlideA11yString;
      return label.replace("[slide_number]", currentIndex + 1);
    }
    return theme.sliders;
  })()),
  (theme.Product = (function () {
    function Product(container) {
      (this.$container = $(container)),
        (this.sectionId = this.$container.attr("data-section-id")),
        (this.selectors = {
          $html: $("html"),
          $productImageGallery: $(".gallery__item", this.$container),
          $productImages: $(".product-single__image-wrapper", this.$container),
          $thumbImages: $("#ProductThumbs", this.$container).find("a.product-single__thumbnail"),
          $productGridImages: $(".grid-link__image--product", this.$container),
          $addToCart: $("#AddToCart", this.$container),
          $productPrice: $("#ProductPrice", this.$container),
          $comparePrice: $("#ComparePrice", this.$container),
          $comparePriceA11y: $("#ComparePriceA11y", this.$container),
          $priceA11y: $("#PriceA11y", this.$container),
          $quantityElements: $(".product-single__quantity", this.$container),
          $addToCartText: $("#AddToCartText", this.$container),
          $tabTrigger: $(".tab-switch__trigger", this.$container),
          $tabContent: $(".tab-switch__content", this.$container),
          $productFullDetails: $(".product-single__full-details", this.$container),
          $SKU: $(".variant-sku", this.$container),
          $shopifyPaymentButton: $(".shopify-payment-button", this.$container),
        }),
        $("#ProductJson-" + this.sectionId).html() &&
          ((this.zoomType = this.$container.data("image-zoom-type")),
          (this.showExtraTab = this.$container.data("show-extra-tab") || !1),
          (this.extraTabContent = this.$container.data("extra-tab-content") || ""),
          (this.relatedEnabled = this.$container.data("related-enabled") || !1),
          (this.enableHistoryState = this.$container.data("enable-history-state") || !1),
          (this.$productGridImages = $(this.selectors.productGridImages, this.$container)),
          (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + this.sectionId).innerHTML)),
          this.init());
    }
    return (
      (Product.prototype = _.assignIn({}, Product.prototype, {
        init: function () {
          this.initBreakpoints(),
            this.initProductVariant(),
            this.productImageSwitch(),
            timber.autoResponsiveElements(),
            this.zoomType === "lightbox" ? this.productImageGallery() : this.zoomType === "zoom-in" && this.productImageZoom(),
            (!this.showExtraTab || this.extraTabContent) && this.initProductTabs(),
            this.relatedEnabled && (theme.cacheSelectors(), theme.equalHeights(this.selectors.$productGridImages));
        },
        initBreakpoints: function () {
          var self2 = this;
          enquire.register(theme.variables.mediaQueryMedium, {
            match: function () {
              self2.zoomType === "zoom-in"
                ? self2.selectors.$productImages.length && (self2.selectors.$productImages.trigger("zoom.destroy"), self2.selectors.$productImages.off(), self2.selectors.$productImages.removeClass("image-zoom"))
                : self2.zoomType === "lightbox" &&
                  (self2.selectors.$productImageGallery.off(),
                  self2.selectors.$productImages.each(function () {
                    $(this).removeClass("zoom-lightbox");
                  })),
                (theme.variables.bpSmall = !0);
            },
            unmatch: function () {
              (theme.variables.bpSmall = !1),
                self2.zoomType === "zoom-in"
                  ? self2.productImageZoom()
                  : self2.zoomType === "lightbox" &&
                    (self2.selectors.$productImages.each(function () {
                      $(this).addClass("zoom-lightbox");
                    }),
                    self2.productImageGallery());
            },
          });
        },
        productImageGallery: function () {
          if (!theme.variables.bpSmall && this.selectors.$productImageGallery.length) {
            this.selectors.$productImageGallery.magnificPopup({
              type: "image",
              mainClass: "mfp-fade",
              closeOnBgClick: !0,
              closeBtnInside: !1,
              closeOnContentClick: !0,
              tClose: theme.strings.zoomClose,
              removalDelay: 500,
              callbacks: {
                open: function () {
                  $("html").css("overflow-y", "hidden");
                },
                close: function () {
                  $("html").css("overflow-y", "");
                },
              },
              gallery: {
                enabled: !0,
                navigateByImgClick: !1,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
                tPrev: theme.strings.zoomPrev,
                tNext: theme.strings.zoomNext,
              },
            });
            var $productImageGallery = this.selectors.$productImageGallery;
            this.selectors.$productImages.each(function () {
              $(this).bind("click", function () {
                var imageId = $(this).attr("data-image-id");
                $productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger("click");
              });
            });
          }
        },
        productImageSwitch: function () {
          if (this.selectors.$thumbImages.length) {
            var self2 = this;
            this.selectors.$thumbImages.on("click", function (evt) {
              evt.preventDefault();
              var newImageId = $(this).attr("data-image-id");
              self2.switchImage(newImageId);
            });
          }
        },
        initProductTabs: function () {
          if (this.selectors.$tabTrigger.length) {
            var $trigger = this.selectors.$tabTrigger,
              $content = this.selectors.$tabContent,
              $el,
              link;
            $content.filter(":gt(0)").addClass("is-hidden"),
              $trigger.first().addClass("is-active"),
              $trigger.on("click", function (evt) {
                evt.preventDefault(),
                  $trigger.removeClass("is-active"),
                  ($el = $(this).addClass("is-active")),
                  (link = $el.data("link")),
                  $content.addClass("is-hidden"),
                  $content.filter('[data-content="' + link + '"]').removeClass("is-hidden");
              });
          }
        },
        initProductVariant: function () {
          var self2 = this,
            product = this.productSingleObject,
            selectCallback = function (variant, selector) {
              self2.productPage({
                money_format: theme.moneyFormat,
                variant: variant,
                selector: selector,
                translations: { add_to_cart: theme.strings.addToCart, sold_out: theme.strings.soldOut, unavailable: theme.strings.unavailable },
              });
            };
          (this.optionSelector = new Shopify.OptionSelectors("ProductSelect-" + this.sectionId, { product: product, onVariantSelected: selectCallback, enableHistoryState: this.enableHistoryState })),
            product.options.length === 1 && product.options[0] !== "Title" && $(".selector-wrapper:eq(0)", this.$container).prepend('<label for="productSelect-option-0">' + product.options[0] + "</label>"),
            product.variants.length === 1 && product.variants[0].title.toLowerCase().indexOf("default") !== -1 && $(".selector-wrapper", this.$container).hide();
        },
        productPage: function (options) {
          var self2 = this,
            moneyFormat = options.money_format,
            variant = options.variant,
            translations = options.translations;
          if (variant) {
            if (variant.featured_image) {
              var newImg = variant.featured_image;
              self2.switchImage(newImg.id);
            }
            if (variant.available) {
              console.log(variant.title),
                this.selectors.$addToCart.removeClass("disabled").prop("disabled", !1),
                this.selectors.$addToCartText.html(translations.add_to_cart),
                this.selectors.$quantityElements.show(),
                this.selectors.$shopifyPaymentButton.show();
              var $link = $(this.selectors.$productFullDetails, this.$container);
              $link.length && $link.attr("href", this.updateUrlParameter($link.attr("href"), "variant", variant.id));
            } else this.selectors.$addToCart.addClass("disabled").prop("disabled", !0), this.selectors.$addToCartText.html(translations.sold_out), this.selectors.$quantityElements.hide(), this.selectors.$shopifyPaymentButton.hide();
            this.selectors.$productPrice.html(Shopify.formatMoney(variant.price, moneyFormat)),
              this.selectors.$SKU.html(variant.sku),
              variant.compare_at_price > variant.price
                ? (this.selectors.$comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).removeClass("hide"),
                  this.selectors.$comparePriceA11y.attr("aria-hidden", "false"),
                  this.selectors.$priceA11y.attr("aria-hidden", "false"))
                : (this.selectors.$comparePrice.addClass("hide").html(""), this.selectors.$comparePriceA11y.attr("aria-hidden", "true"));
          } else this.selectors.$addToCart.addClass("disabled").prop("disabled", !0), this.selectors.$addToCartText.html(translations.unavailable), this.selectors.$quantityElements.hide(), this.selectors.$shopifyPaymentButton.hide();
        },
        updateUrlParameter: function (url, key, value) {
          var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i"),
            separator = url.indexOf("?") === -1 ? "?" : "&";
          return url.match(re) ? url.replace(re, "$1" + key + "=" + value + "$2") : url + separator + key + "=" + value;
        },
        switchImage: function (imageId) {
          var $newImage = $(this.selectors.$productImages.selector + "[data-image-id='" + imageId + "']", this.$container),
            $otherImages = $(this.selectors.$productImages.selector + ":not([data-image-id='" + imageId + "'])", this.$container);
          $newImage.removeClass("hide"), $otherImages.addClass("hide");
        },
        productImageZoom: function () {
          (theme.variables.bpSmall && this.zoomType !== "zoom-in") ||
            !this.selectors.$productImages.length ||
            this.selectors.$html.hasClass("supports-touch") ||
            (this.selectors.$productImages.trigger("zoom.destroy"),
            this.selectors.$productImages.each(function () {
              $(this)
                .addClass("image-zoom")
                .zoom({ url: $(this).find("img").attr("data-zoom") });
            }));
        },
      })),
      Product
    );
  })()),
  (theme.Collection = (function () {
    function Collection(container) {
      (this.$container = $(container)),
        (this.selectors = { productGridImages: ".grid-link__image--product" }),
        (this.sortEnabled = this.$container.data("sort-enabled")),
        (this.tagsEnabled = this.$container.data("tags-enabled")),
        (this.$productGridImages = $(this.selectors.productGridImages, this.$container)),
        this.init();
    }
    return (
      (Collection.prototype = _.assignIn({}, Collection.prototype, {
        init: function () {
          this.stringOverrides(), theme.cacheSelectors(), theme.equalHeights(this.$productGridImages), this.sortEnabled && this.collectionSorting(), this.tagsEnabled && this.collectionTags();
        },
        stringOverrides: function () {
          (theme.productStrings = theme.productStrings || {}), $.extend(theme.strings, theme.productStrings);
        },
        collectionSorting: function () {
          if (((Shopify.queryParams = {}), location.search.length && location.search.indexOf("sort_by")))
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++)
              (aKeyValue = aCouples[i].split("=")), aKeyValue.length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
          $(function () {
            $("#SortBy")
              .val(theme.strings.sortBy)
              .bind("change", function () {
                (Shopify.queryParams.sort_by = $(this).val()), (location.search = $.param(Shopify.queryParams));
              });
          });
        },
        collectionTags: function () {
          var $browseBy = $("#BrowseBy");
          $(function () {
            $browseBy.bind("change", function () {
              location.href = $browseBy.val();
            });
          });
        },
      })),
      Collection
    );
  })()),
  (theme.ListCollections = (function () {
    function ListCollections(container) {
      (this.$container = $(container)), (this.selectors = { collectionGridImages: ".grid-link__image--collection" }), (this.$collectionGridImages = $(this.selectors.collectionGridImages, this.$container)), this.init();
    }
    return (
      (ListCollections.prototype = _.assignIn({}, ListCollections.prototype, {
        init: function () {
          theme.cacheSelectors(), theme.equalHeights(this.$collectionGridImages);
        },
      })),
      ListCollections
    );
  })()),
  (theme.Cart = (function () {
    var selectors = { body: "body", cartSection: "#CartSection", cartNoteAdd: ".cart__note-add", cartNote: ".cart__note", cartNoCookies: "cart--no-cookies" };
    function Cart() {
      cookiesEnabled() || $(selectors.cartSection).addClass(selectors.cartNoCookies),
        $(selectors.cartSection).data("notes-enable") &&
          $(selectors.body).on("click", selectors.cartNoteAdd, function () {
            $(this).addClass("is-hidden"), $(selectors.cartNote).addClass("is-active");
          });
    }
    function cookiesEnabled() {
      var cookieEnabled = navigator.cookieEnabled;
      return cookieEnabled || ((document.cookie = "testcookie"), (cookieEnabled = document.cookie.indexOf("testcookie") !== -1)), cookieEnabled;
    }
    return Cart;
  })()),
  (theme.Header = (function () {
    function Header() {
      (this.selectors = {
        headerBar: ".header-bar",
        mobileNavTrigger: "#MobileNavTrigger",
        mobileNav: "#MobileNav",
        mobileSublistTrigger: ".mobile-nav__sublist-trigger",
        showDropdownClass: "show-dropdown",
        hasDropdownItem: ".site-nav--has-dropdown",
        body: "body",
      }),
        this.init();
    }
    return (
      (Header.prototype = _.assignIn({}, Header.prototype, {
        init: function () {
          var self2 = this;
          this.cacheSelectors(),
            cache.$mobileNavTrigger.on("click.mobileNavTrigger", function (evt) {
              evt.preventDefault();
              var isExpanded = $(this).attr("aria-expanded");
              isExpanded === "true" ? self2.menuClose() : self2.menuOpen();
            }),
            cache.$mobileSublistTrigger.on("click.mobileSublistTrigger", function (evt) {
              var $el = $(this),
                isExpanded = $el.attr("aria-expanded") === "true";
              evt.preventDefault(),
                $el.toggleClass("is-active").next(".mobile-nav__sublist").stop().slideToggle(200),
                $el.attr("aria-expanded", !isExpanded),
                !$el.hasClass(self2.selectors.showDropdownClass) && timber.vars.isTouch && (evt.preventDefault(), $el.addClass(self2.selectors.showDropdownClass), cache.$doc.on("click.mobileNav", handleClickOutsideDropdown));
              function handleClickOutsideDropdown(evt2) {
                var $target = $(evt2.target);
                !$target.is($el) && !$.contains($el[0], $target[0]) && ($el.removeClass(self2.selectors.showDropdownClass), cache.$doc.off(".mobileNav"));
              }
            });
        },
        cacheSelectors: function () {
          (window.cache = window.cache || {}),
            $.extend(window.cache, {
              $doc: $(document),
              $headerBar: $(this.selectors.headerBar),
              $mobileNavTrigger: $(this.selectors.mobileNavTrigger),
              $mobileNav: $(this.selectors.mobileNav),
              $mobileSublistTrigger: $(this.selectors.mobileSublistTrigger),
              $hasDropdownItem: $(this.selectors.hasDropdownItem),
            });
        },
        onUnload: function () {
          cache.$mobileNavTrigger.off(".mobileNavTrigger"), cache.$mobileSublistTrigger.off(".mobileSublistTrigger");
        },
        menuOpen: function () {
          var self2 = this;
          cache.$mobileNavTrigger.attr("aria-expanded", "true"),
            cache.$mobileNav.slideDown(220),
            theme.a11y.trapFocus({ $container: cache.$headerBar, $elementToFocus: cache.$mobileNav.find("> li:first-child a"), namespace: "drawerMenu" }),
            theme.cache.$html.on("keyup.drawerMenu", function (evt) {
              evt.keyCode === 27 && self2.menuClose();
            }),
            $(self2.selectors.body).on("mousedown", function (evt) {
              evt.target.closest(self2.selectors.headerBar) || theme.a11y.removeTrapFocus({ $container: cache.$headerBar, namespace: "drawerMenu" });
            });
        },
        menuClose: function () {
          cache.$mobileNavTrigger.attr("aria-expanded", "false"), cache.$mobileNav.slideUp(220), theme.cache.$html.off("keyup.drawerMenu"), theme.a11y.removeTrapFocus({ $container: cache.$headerBar, namespace: "drawerMenu" });
        },
      })),
      Header
    );
  })()),
  (theme.slideshows = {}),
  (theme.SlideshowSection = (function () {
    function SlideshowSection(container) {
      this.$container = $(container);
      var id = this.$container.attr("data-section-id"),
        slideshow = (this.slideshow = "#flexslider--" + id);
      theme.slideshows[slideshow] = new theme.Hero(slideshow, id);
    }
    return SlideshowSection;
  })()),
  (theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow),
        $slide = $("#slide--" + evt.detail.blockId + ":not(.clone)"),
        slideIndex = $slide.data("flexslider-index"),
        $slideImg = $slide.find("img");
      $slideshow.flexslider(slideIndex, !0), $slideshow.flexslider("pause"), $slideImg.on("load", this.resizeOnImageLoad($slideImg)).bind(this);
    },
    onSelect: function () {
      var $slideshow = $(this.slideshow),
        $slideImg = $slideshow.find("img").first();
      $slideImg.on("load", this.resizeOnImageLoad($slideImg)).bind(this);
    },
    onBlockDeselect: function () {
      var $slideshow = $(this.slideshow);
      $slideshow.data("autoplay") && $(this.slideshow).flexslider("play");
    },
    resizeOnImageLoad: function ($slideImg) {
      var intervalAttempts = 0,
        $slideshow = $(this.slideshow),
        imageHeightCheck = setInterval(function () {
          intervalAttempts++, $slideImg.length && $slideImg.height() === 0 && intervalAttempts < 10 ? sizeSlideshow($slideshow) : (sizeSlideshow($slideshow), clearInterval(imageHeightCheck));
        }, 500);
      function sizeSlideshow($slideshow2) {
        $slideshow2.resize();
      }
    },
  })),
  (theme.CollectionList = (function () {
    function CollectionList(container) {
      (this.$container = $(container)), (this.selectors = { collectionGridImages: ".grid-link__image--collection" }), (this.$collectionGridImages = $(this.selectors.collectionGridImages, this.$container)), this.init();
    }
    return (
      (CollectionList.prototype = _.assignIn({}, CollectionList.prototype, {
        init: function () {
          theme.cacheSelectors(), theme.equalHeights(this.$collectionGridImages);
        },
      })),
      CollectionList
    );
  })()),
  (theme.FeaturedProducts = (function () {
    function FeaturedProducts(container) {
      (this.$container = $(container)), (this.selectors = { productGridImages: ".grid-link__image--product" }), (this.$productGridImages = $(this.selectors.productGridImages, this.$container)), this.init();
    }
    return (
      (FeaturedProducts.prototype = _.assignIn({}, FeaturedProducts.prototype, {
        init: function () {
          theme.cacheSelectors(), theme.equalHeights(this.$productGridImages);
        },
      })),
      FeaturedProducts
    );
  })()),
  (theme.Maps = (function () {
    var config = { zoom: 14 },
      apiStatus = null,
      mapsToLoad = [];
    function Map(container) {
      theme.$currentMapContainer = this.$container = $(container);
      var key = this.$container.data("api-key");
      if (!(typeof key != "string" || key === ""))
        if (apiStatus === "loaded") {
          var self2 = this,
            $script = $('script[src*="' + key + '&"]');
          $script.length === 0
            ? $.getScript("https://maps.googleapis.com/maps/api/js?key=" + key).then(function () {
                (apiStatus = "loaded"), self2.createMap();
              })
            : this.createMap();
        } else
          mapsToLoad.push(this),
            apiStatus !== "loading" &&
              ((apiStatus = "loading"),
              typeof window.google == "undefined" &&
                $.getScript("https://maps.googleapis.com/maps/api/js?key=" + key).then(function () {
                  (apiStatus = "loaded"), initAllMaps();
                }));
    }
    function initAllMaps() {
      $.each(mapsToLoad, function (index, instance) {
        instance.createMap();
      });
    }
    function geolocate($map) {
      var deferred = $.Deferred(),
        geocoder = new google.maps.Geocoder(),
        address = $map.data("address-setting");
      return (
        geocoder.geocode({ address: address }, function (results, status2) {
          status2 !== google.maps.GeocoderStatus.OK && deferred.reject(status2), deferred.resolve(results);
        }),
        deferred
      );
    }
    return (
      (Map.prototype = _.assignIn({}, Map.prototype, {
        createMap: function () {
          var $map = this.$container.find(".map-section__container");
          return geolocate($map)
            .then(
              function (results) {
                var mapOptions = { zoom: config.zoom, styles: config.styles, center: results[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                  map = (this.map = new google.maps.Map($map[0], mapOptions)),
                  center = (this.center = map.getCenter()),
                  marker = new google.maps.Marker({ map: map, position: center });
                google.maps.event.addDomListener(window, "resize", function () {
                  google.maps.event.trigger(map, "resize"), map.setCenter(center);
                });
              }.bind(this)
            )
            .fail(function () {
              var errorMessage;
              switch (status) {
                case "ZERO_RESULTS":
                  errorMessage = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  errorMessage = theme.strings.addressQueryLimit;
                  break;
                default:
                  errorMessage = theme.strings.addressError;
                  break;
              }
              if (Shopify.designMode) {
                var $mapContainer = $map.parents(".map-section");
                $mapContainer.addClass("page-width map-section--load-error"), $mapContainer.find(".map-section__wrapper").html('<div class="errors text-center">' + errorMessage + "</div>");
              }
            });
        },
        onUnload: function () {
          typeof window.google != "undefined" && google.maps.event.clearListeners(this.map, "resize");
        },
      })),
      Map
    );
  })());
function gm_authFailure() {
  Shopify.designMode && (theme.$currentMapContainer.addClass("page-width map-section--load-error"), theme.$currentMapContainer.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"));
}
(window.theme = window.theme || {}),
  (theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init();
    }
    return (
      (PasswordHeader.prototype = _.assignIn({}, PasswordHeader.prototype, {
        init: function () {
          $(".js-toggle-login-modal").magnificPopup({
            type: "inline",
            mainClass: "mfp-fade",
            closeOnBgClick: !1,
            closeBtnInside: !1,
            closeOnContentClick: !1,
            tClose: password.strings.pageClose,
            removalDelay: 500,
            callbacks: {
              open: function () {
                window.setTimeout(function () {
                  document.getElementById("password").focus();
                }, 50),
                  $("html").css("overflow-y", "hidden");
              },
              close: function () {
                $("html").css("overflow-y", "");
              },
            },
          }),
            $(".storefront-password-form .errors").size() && $(".js-toggle-login-modal").click();
        },
      })),
      PasswordHeader
    );
  })()),
  $(document).ready(function () {
    var sections = new theme.Sections();
    sections.register("product-template", theme.Product),
      sections.register("collection-template", theme.Collection),
      sections.register("list-collections-template", theme.ListCollections),
      sections.register("cart-template", theme.Cart),
      sections.register("article-template", theme.Article),
      sections.register("header-section", theme.Header),
      sections.register("slideshow-section", theme.SlideshowSection),
      sections.register("collection-list-section", theme.CollectionList),
      sections.register("featured-products-section", theme.FeaturedProducts),
      sections.register("map-section", theme.Maps),
      sections.register("password-header", theme.PasswordHeader);
  }),
  (theme.cacheSelectors = function () {
    theme.cache = { $w: $(window), $html: $("html") };
  }),
  (timber.cacheVariables = function () {
    timber.vars = { isTouch: timber.cache.$html.hasClass("supports-touch") };
  }),
  (theme.init = function () {
    theme.cacheSelectors(), timber.cacheVariables(), theme.productCardImageLoadingAnimation();
  }),
  (theme.productCardImageLoadingAnimation = function () {
    var selectors = { image: "[data-image]", imageWrapper: "[data-image-wrapper]" },
      classes = { loadingAnimation: "grid-link__image--loading", lazyloaded: ".lazyloaded" };
    $(document).on("lazyloaded", function (e) {
      var $target = $(e.target);
      $target.is(selectors.image) && $target.closest(selectors.imageWrapper).removeClass(classes.loadingAnimation);
    }),
      $(selectors.image + classes.lazyloaded)
        .closest(selectors.imageWrapper)
        .removeClass(classes.loadingAnimation);
  }),
  (theme.equalHeights = function ($selector) {
    theme.cache.$w.on("load", resizeElements($selector)),
      theme.cache.$w.on(
        "resize",
        afterResize(
          function () {
            resizeElements($selector);
          },
          250,
          "equal-heights"
        )
      );
    function resizeElements($selector2) {
      $selector2.imagesLoaded(function () {
        $selector2.css("height", "auto").equalHeights();
      });
    }
  }),
  $(theme.init),
  (function ($2) {
    var MegaMenu = {
        init: function () {
          var __this = this;
          (this.rel = $2.trim(this.find("[data-dropdown]").attr("data-dropdown").toLowerCase())),
            (this.isMobile = 0),
            this.timer,
            (this.btn = null),
            $2(window)
              .resize(function () {
                $2(".site-header__mobile").css("display") == "block" ? (__this.isMobile = 1) : (__this.isMobile = 0);
              })
              .trigger("resize"),
            this.find('[href*="#back"]').on("click", function () {
              $2("body").removeAttr("mobile-menu__mobile"), __this.removeClass("active");
            }),
            (cnt = 0),
            $2(".site-nav a").each(function () {
              (intVal = $2.trim($2(this).text().toLowerCase())), intVal == __this.rel && (__this.btn == null ? ((__this.btn = $2(this)), console.log("first")) : (__this.btn = __this.btn.add($2(this))));
            }),
            this.btn.each(function () {
              if ($2(this).closest(".site-header").is(".site-header__mobile")) {
                $2("<span>&#9662;</span>").appendTo($2(this).parent());
                var plusMenuTrigger = theme.plus.menuType == "arrow" ? $2(this).parent().find("span") : $2(this).parent();
                plusMenuTrigger.on("click", function (e) {
                  e.preventDefault(), $2("body").attr("mobile-menu__mobile", 1), __this.openMenu();
                });
              } else
                $2("<span>&#9662;</span>").appendTo($2(this)),
                  $2(this).hover(
                    function () {
                      __this.openMenu();
                    },
                    function () {
                      __this.startCloseMenu();
                    }
                  );
            }),
            this.hover(
              function () {
                __this.openMenu();
              },
              function () {
                this.isMobile || __this.startCloseMenu();
              }
            ),
            $2(window)
              .resize(function () {
                (intTop = $2("#shopify-section-header").offset().top + $2("#shopify-section-header").outerHeight()), __this.css("top", intTop);
              })
              .trigger("resize");
        },
        openMenu: function () {
          var __this = this;
          clearTimeout(__this.timer), this.addClass("active");
        },
        startCloseMenu: function () {
          var __this = this;
          $2("body").is("[mobile-menu__mobile]") ||
            (this.timer = setTimeout(function () {
              __this.closeMenu();
            }, 250));
        },
        closeMenu: function () {
          var __this = this;
          this.removeClass("active");
        },
      },
      Dropper = {
        init: function () {
          var __this = this;
          (this.rel = this.find("[data-rel]")),
            this.timer,
            $2(".site-header .site-nav a").each(function () {
              (intVal = $2.trim($2(this).text().toLowerCase())), intVal == __this.rel && (__this.btn = $2(this));
            }),
            this.hover(
              function () {
                __this.openMenu();
              },
              function () {
                __this.startCloseMenu();
              }
            );
        },
        openMenu: function () {
          var __this = this;
          clearTimeout(__this.timer), this.addClass("active");
        },
        startCloseMenu: function () {
          var __this = this;
          this.timer = setTimeout(function () {
            __this.closeMenu();
          }, 250);
        },
        closeMenu: function () {
          var __this = this;
          this.removeClass("active");
        },
      },
      Selector = {
        init: function () {
          var __this = this;
          this.cont, this.runSetup();
        },
        runSetup: function () {
          var __this = this;
          (this.cont = $2('<div class="selector"></div>')),
            this.cont.insertBefore(__this.parent()),
            this.find("option").each(function () {
              (intOpt = $2(this)),
                (intVal = $2(this).text()),
                $2(this).attr("data-rel", intVal),
                (int = $2('<a role="button" href="' + intOpt.val() + '">' + intOpt.text() + "</a>")),
                int.data("rel", intOpt),
                int[0].offsetHeight,
                int.appendTo(__this.cont).click(function (e) {
                  e.preventDefault(), $2(this).addClass("active").siblings().removeClass("active"), __this.find('option[value="' + $2(this).attr("href") + '"]').prop("selected", "selected"), __this.trigger("change");
                }),
                intOpt.is("[selected]") && int.trigger("click");
            });
        },
      },
      Accordion = {
        init: function () {
          var __this = this;
          (this.dt = this.find("dt")),
            (this.dd = this.find("dd")),
            this.dt.each(function () {
              $2(this).on("click", function () {
                __this.runClick($2(this));
              });
            });
        },
        runClick: function (el2) {
          var __this = this;
          (intDD = el2.next()),
            this.dd.each(function () {
              $2(this).height(0);
            }),
            el2.is(".active") ? el2.removeClass("active") : (intDD.height(intDD.find("> div").outerHeight()), el2.addClass("active").siblings().removeClass("active"));
        },
      },
      MobileMenu = {
        init: function () {
          var __this = this;
          this.click(function () {
            $2("body").is("[mobile-menu]") ? $2("body").removeAttr("mobile-menu").removeAttr("mobile-menu__mobile") : $2("body").attr("mobile-menu", 1), $2(".mega-menu, .mega-menu-section").removeClass("active");
          }),
            $2(".site-header:not(.site-header__mobile) .site-nav a").each(function () {
              (intVal = $2.trim($2(this).text().toLowerCase())), intVal == __this.rel && (__this.btn = $2(this));
            });
        },
      },
      Spinner = {
        init: function () {
          var __this = this;
          (this.cnt = 0), this.runAnimation();
        },
        runAnimation: function () {
          var __this = this;
          this.cnt % 2 ? (this.addClass("jump"), this[0].offsetHeight, this.removeClass("end").addClass("start"), this[0].offsetHeight, this.removeClass("jump").removeClass("start")) : this.addClass("end"),
            this.cnt++,
            setTimeout(function () {
              __this.runAnimation();
            }, 2500);
        },
      },
      ColumnBlock = {
        init: function () {
          var __this = this;
          this.cnt, (this.timer = null), (this.img = this.find(" > img")), (this.slideLength = this.img.length), this.slideLength > 1 && (this.addClass("slider"), this.setupSlider());
        },
        setupSlider: function () {
          var __this = this;
          (this.ul = $2("<ul></ul>")),
            this.ul.appendTo(__this),
            this.img.each(function () {
              $2("<li></li>")
                .appendTo(__this.ul)
                .on("click", function () {
                  __this.runSlide($2(this));
                });
            }),
            (this.li = this.ul.find("li")),
            (this.cnt = this.li.first().index()),
            this.runTimer();
        },
        runSlide: function (el2) {
          var __this = this;
          el2.addClass("active").siblings().removeClass("active"),
            (intIndex = el2.index()),
            (intEl = this.img.eq(intIndex)),
            intEl[0].offsetHeight,
            intEl.addClass("jump").addClass("start"),
            intEl[0].offsetHeight,
            intEl.removeClass("jump"),
            intEl[0].offsetHeight,
            intEl.addClass("active").removeClass("start"),
            intEl.siblings().removeClass("active"),
            (this.cnt = intIndex + 1),
            clearTimeout(__this.timer),
            (__this.timer = setTimeout(function () {
              __this.runTimer();
            }, 6e3));
        },
        runTimer: function () {
          var __this = this;
          (this.cnt = this.cnt % this.li.length),
            clearTimeout(__this.timer),
            this.li.eq(this.cnt).trigger("click"),
            this.cnt++,
            (this.timer = setTimeout(function () {
              __this.runTimer();
            }, 6e3));
        },
      },
      Headerer = {
        init: function () {
          var __this = this;
          (this.timeVal = this[0].dataset.animationDuration),
            (this.el = $2(this).find("a").length ? $2(this).find("a") : this),
            this.setupEl(),
            $2(window)
              .resize(function () {
                __this.elWidth = __this.find("b").first().outerWidth();
              })
              .trigger("resize"),
            this.runEl();
        },
        setupEl: function () {
          var __this = this;
          for (intTxt = this.text(), this.el.text(""), this.cont = $2("<span></span>"), this.cont.appendTo(this.el), x = 0; x < 10; x++) $2("<b>" + intTxt + "</b>").appendTo(this.cont);
        },
        runEl: function () {
          var __this = this;
          (el = this.cont),
            el.css("transition-duration", "0s"),
            el.css("transform", "translateX( 0 )"),
            el[0].offsetHeight,
            el.css("transition-duration", this.timeVal + "ms"),
            el.css("transform", "translateX( -" + this.elWidth + "px )"),
            setTimeout(function () {
              __this.runEl();
            }, this.timeVal);
        },
      };
    $2(document).ready(function () {
      $2(".column-block h2").each(function () {
        (el = $2(this)), $2.extend(el, Headerer), el.init();
      }),
        $2(".column-block .block").each(function () {
          (el = $2(this)), $2.extend(el, ColumnBlock), el.init();
        }),
        $2(".column-block.mobile-single").each(function () {
          $2(this).find("img").first().clone().prependTo($2(this));
        }),
        $2('[href*="#menu"]').each(function () {
          (el = $2(this)), $2.extend(el, MobileMenu), el.init();
        }),
        $2("[data-spinner]").each(function () {
          (int = $2(this).data("obj", $2(this))), $2.extend(int, Spinner), int.init();
        }),
        $2("[data-dropdown]").each(function () {
          (int = $2(this).data("obj", $2(this))), $2.extend(int, Dropper), int.init();
        }),
        $2('.shopify-section[class*="mega-menu"]').each(function () {
          (int = $2(this).data("obj", $2(this))), $2.extend(int, MegaMenu), int.init();
        }),
        $2(".single-option-selector").each(function () {
          (int = $2(this)), $2.extend(int, Selector), int.init();
        }),
        $2(".accordion").each(function () {
          (int = $2(this)), $2.extend(int, Accordion), int.init();
        }),
        $2('[href*="#search"]').on("click", function () {
          $2("body").is("[search-active]") ? $2("body").removeAttr("search-active") : $2("body").attr("search-active", 1);
        }),
        $2('form[action*="cart/add"]').on("submit", function (e) {
          e.preventDefault(), $2.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: $2(this).serialize(), success: addToCartOk, error: addToCartFail });
        });
      function addToCartOk(data) {
        console.log(JSON.stringify(data)), $2(".add-to-cart--product").text(data.product_title), $2("#add-to-cart").addClass("active"), $2("body").attr("add-to-cart", "1");
      }
      function addToCartFail(data) {}
      $2('[href *= "#close"]').on("click", function () {
        $2("#add-to-cart").removeClass("active"), $2("body").removeAttr("add-to-cart");
      }),
        $2("p").each(function () {
          var $this = $2(this);
          $this.html().replace(/\s|&nbsp;/g, "").length == 0 && $this.remove();
        }),
        $2("video").each(function () {
          (int = $2(this)[0]),
            (banner = $2(this).closest(".banner")),
            $2(this)
              .closest(".banner")
              .on("click", function () {
                $2(this).is("[data-video]") ? ($2(this).find("video")[0].pause(), $2(this).removeAttr("data-video")) : ($2(this).find("video")[0].play(), $2(this).attr("data-video", 1));
              }),
            (int.onloadeddata = function () {
              $2(this).closest(".banner").attr("data-loaded", "1");
            }),
            (int.onplay = function () {
              $2(this).closest(".banner").attr("data-video", "1");
            });
        }),
        $2(window)
          .resize(function () {
            (intFoot = $2("#shopify-section-footer")), (intMain = $2("main")), (footHeight = intFoot.outerHeight()), (intHeight = $2(window).height() - footHeight - intMain.offset().top), intMain.css("min-height", intHeight);
          })
          .trigger("resize");
    });
  })(jQuery);
//# sourceMappingURL=/s/files/1/0076/4438/1281/t/16/assets/theme.js.map?v=1682421503
